<template>
  <div>
    <banner ref="header" @gettoken="gettoken"></banner>
    <cebianlan></cebianlan>
    <!-- 课程详情 -->
    <div class="details">
      <div class="yuyuyu">
        <el-dialog
          :visible.sync="code"
          title=""
          width="320px"
          style="border-radius: 40px"
          center
        >
          <h3 style="text-align: center" class="kechengduihuan">课程兑换码</h3>
          <p class="huoqulist">（兑换码请到相关老师处获取）</p>
          <el-form
            label-width="120px"
            label-suffix="："
            style="margin-top: 30px; margin-bottom: 20px"
          >
            <div class="duihuan-content">
              <el-input v-model="codeData" placeholder="请输入兑换码" />
              <div slot="footer">
                <div class="lijiduan" type="primary" @click="useCdk()">
                  兑换
                </div>
              </div>
            </div>
            <div style="height: 20px">
              <p class="yiguoqilist">{{ this.errData }}</p>
            </div>
          </el-form>
        </el-dialog>
      </div>
      <div class="container">
        <!-- 详情头部 -->
        <div class="details-header">
          {{ course.cateNameChain }}-> {{ course.name }}
        </div>
        <!-- 视频部分 -->
        <div class="video">
          <div class="course-content-main">
            <div
              :class="BrowserF == 0?'course-img':'course-imgyi'"
              :style="{ backgroundImage: 'url(' + course.cover + ')' }"
              v-if="!playStatus"
            ></div>
            <div :class="BrowserF == 0?'course-img':'course-imgyi'" v-show="playStatus">
              <template v-if="isThreeScreenCourse">
                <div id="whiteBoardTopDiv"></div>
                <div style="height: 100%; background: #000000" id="whiteBoard">
                  <SHPlayer
                    v-if="playerThreeType == 'cPlayer'"
                    videoType="vod"
                    class="main-video"
                    ref="whiteBoard"
                    :speedValue="whiteBoardSpeed"
                    :playerType="playerThreeType"
                    :hideProgress="false"
                    :showRate="true"
                    :spaceControl="false"
                    :isThreeScreen="isThreeScreenCourse"
                    @playSpeed="handlePlaySpeed"
                    @loadstart="onLoadstart"
                    @play="handlePlay"
                    @playing="playingFn"
                    @pause="handlePause"
                    @toggle-mute="handleToggleMute"
                    @cutSwitch="cutSwitch"
                    @getDuration="getWhiteDuration"
                    @changeVolume="changeVolume"
                    @seeking="handleWhiteSeek"
                    @clickMouseDown="whiteMouseDown"
                    @BrowserFullScreen="BrowserFullScreens"
                    :fans_id="fans_id"
                    :subtitles="videoSubtitlesContents"
                    :openSubtitles="subtitlesStatus"
                    :subtitleOptions="subtitleOptions"
                    :cameraVideoCurTime="progressTime"
                    :runObj="runObj"
                    :copyrightObj="copyrightObj"
                    :nick="nick"
                    :remark="remark"
                    :volume="volume"
                    :orgId="org_id"
                  />
                  <SHPlayer
                    v-else
                    videoType="vod"
                    class="main-video"
                    ref="whiteBoard"
                    :speedValue="whiteBoardSpeed"
                    :playerType="playerThreeType"
                    :hideProgress="false"
                    :showRate="true"
                    :spaceControl="false"
                    :isThreeScreen="isThreeScreenCourse"
                    @playSpeed="handlePlaySpeed"
                    @loadedmetadata="onLoadstart"
                    @play="handlePlay"
                    @playing="playingFn"
                    @pause="handlePause"
                    @toggle-mute="handleToggleMute"
                    @cutSwitch="cutSwitch"
                    @getDuration="getWhiteDuration"
                    @changeVolume="changeVolume"
                    @seeking="handleWhiteSeek"
                    @clickMouseDown="whiteMouseDown"
                    @BrowserFullScreen="BrowserFullScreens"
                    @playLineChange="playLineChange"
                    :fans_id="fans_id"
                    :runObj="runObj"
                    :copyrightObj="copyrightObj"
                    :nick="nick"
                    :remark="remark"
                    :volume="volume"
                    :openSubtitles="subtitlesStatus"
                    :subtitleOptions="subtitleOptions"
                    :subtitles="videoSubtitlesContents"
                    :cameraVideoCurTime="progressTime"
                    :orgId="org_id"
                  />

                  <div class="shangcigk" v-if="memoryPoints != 0 && shangciGk">
                    上次观看至{{ formateSeconds(memoryPoints) }}
                  </div>
                </div>
              </template>
              <template v-else>
                <SHPlayer
                  videoType="vod"
                  ref="mainVideo"
                  @timeupdate="handleListenCurTimeChange"
                  @play="onPlayerPlay"
                  @pause="onPlayerPause"
                  @ended="onPlayerEnded"
                  @unAutoPlay="dayusantishi"
                  @loadedmetadata="onLoadstart"
                  @playSpeed="handlePlaySpeed"
                  @playing="playingFn"
                  @BrowserFullScreen="BrowserFullScreens"
                  class="main-video"
                  :playerType="playerType"
                  :fans_id="fans_id"
                  :runObj="runObj"
                  :copyrightObj="copyrightObj"
                  :nick="nick"
                  :remark="remark"
                  :subtitles="videoSubtitlesContents"
                  :subtitleOptions="subtitleOptions"
                  :openSubtitles="subtitlesStatus"
                  :orgId="org_id"
                  :spaceControl="false"
                />
                <div v-if="memoryPoints != 0 && shangciGk" class="shangcigk">
                  上次观看至{{ formateSeconds(memoryPoints) }}
                </div>
                <div v-if="kuaijieshu" class="shangcigkyi">
                  即将播放下一个 &nbsp;{{ jueshusp.toFixed(0) }}
                </div>
              </template>
              <!-- 中间播放按钮 -->
              <div
                v-loading="seekingFlag && playerThreeType === 'cPlayer'"
                element-loading-background="rgba(0, 0, 0, 0.3)"
                class="overlayer"
                v-show="seekingFlag && playerThreeType === 'cPlayer'"
              ></div>
              <div v-show="showPlayIcon" class="overlayer">
                <img
                  class="change"
                  src="../assets/subtitle/play.png"
                  alt="播放按钮"
                  @click="playVideo"
                />
              </div>
            </div>
            <div class="course-content-main-right">
              <div v-if="isThreeScreenCourse">
                <div id="CameraVideoTopDiv"></div>
                <div :class="BrowserFyi != 0?'course-imgyi':'course-imger'" id="cameraVideo">
                  <SHPlayer
                    @timeupdate="handleListenCurTimeChangeCameraVideo"
                    videoType="vod"
                    ref="cameraVideo"
                    class="camera-video"
                    :speedValue="cameraVideoSpeed"
                    :playerType="'tcPlayer'"
                    :hideProgress="true"
                    :spaceControl="false"
                    @play="onPlayerPlay"
                    @pause="onPlayerPause"
                    @playBtnClicked="onPlayerPlay"
                    @playSpeed="handlePlaySpeed"
                    @ended="onPlayerEnded"
                    @changeVolume="changeVolume"
                    @getDuration="getCameraDuration"
                    @BrowserFullScreen="BrowserFullScreensyi"
                    :isMutedReal="isMuted"
                    :volume="volume"
                    :fans_id="fans_id"
                    :runObj="runObj"
                    :copyrightObj="copyrightObj"
                    :nick="nick"
                    :remark="remark"
                    :isThird="false"
                    :isThreeScreen="isThreeScreenCourse"
                    :orgId="org_id"
                    @cutSwitch="cutSwitch"
                  />
                  <!-- <div class="shangcigk">上次观看至{{formateSeconds(memoryPoints)}}</div> -->
                  <div
                    v-loading="seekingFlag && playerThreeType === 'cPlayer'"
                    element-loading-background="rgba(0, 0, 0, 0.3)"
                    v-show="seekingFlag && playerThreeType === 'cPlayer'"
                    style="
                      position: absolute;
                      top: 0;
                      z-index: 1000;
                      width: 100%;
                      height: 100%;
                      background: rgba(0, 0, 0, 0.5);
                    "
                  ></div>
                  <div
                    v-show="showPlayIcon"
                    style="
                      position: absolute;
                      top: 0;
                      z-index: 1000;
                      width: 100%;
                      height: 100%;
                      background: rgba(0, 0, 0, 0.5);
                    "
                  ></div>
                </div>
              </div>
              <div v-show="!makeNote">
                <div
                  class="course-chapter"
                  ref="course_chapter"
                  :class="isThreeScreenCourse ? 'three-screen-style' : ''"
                >
                  <div class="class-tab" v-if="course.is_enable_caption === 1">
                    <ul class="tab-list">
                      <li
                        class="tab-item"
                        :class="{ active: tabIndex === 1 }"
                        @click="tabChange(1)"
                      >
                        目录
                      </li>
                      <li
                        class="tab-item"
                        :class="{ active: tabIndex === 2 }"
                        @click="tabChange(2)"
                        v-show="subtitlesStatus"
                      >
                        文稿
                      </li>
                    </ul>
                  </div>
                  <!-- 显示文稿 -->
                  <VideoDraft
                    ref="videoDraft"
                    v-show="tabIndex === 2 && subtitlesStatus"
                    :subtitles="videoSubtitlesContents"
                    :isSelectVideo="isSelectVideo"
                    @updatePlayerTime="updatePlayerTime"
                    :classIsThreeScreenCourse="
                      isThreeScreenCourse ? true : false
                    "
                  />
                  <!-- 显示目录 -->
                  <div v-show="tabIndex === 1">
                    <div
                      style="padding: 0 20px; margin-top: 10px"
                      class="sousuozj"
                    >
                      <el-input
                        placeholder="请输入内容"
                        prefix-icon="el-icon-search"
                        v-model="input2"
                        @input="listSections('', 'zhankai')"
                      ></el-input>
                    </div>
                    <template v-if="hasSection">
                      <div
                        v-for="(section, index) in sectionList"
                        :key="section.sectionId"
                        :ref="'part' + section.sectionId"
                        class="chapter-main"
                      >
                        <div
                          class="chapter-title"
                          @click="handleStretchPart(section.sectionId, index)"
                        >
                          <span
                            class="chapter-text"
                            :title="section.sectionName"
                            >{{ section.sectionName }}</span
                          >
                          <i
                            class="iconfont title-icon"
                            :ref="'icon' + section.sectionId"
                            >&#xe665;</i
                          >
                        </div>
                        <div
                          class="course-chapter-item"
                          v-for="(chapter, idx) in section.chapters"
                          :key="chapter.id"
                          :ref="'chapterJie' + chapter.id"
                        >
                          <div class="chapter-item-num">{{ idx + 1 }}</div>
                          <div class="chapter-item-content">
                            <div class="item-content-top" @click="toggleChapter(chapter.id, section.sectionId)" style="cursor: pointer;">
                              <div
                                class="chapter-review"
                                v-if="chapter.type == 3"
                              >
                                回放
                              </div>
                              <div
                                class="chapter-review"
                                v-if="chapter.type == 2"
                              >
                                录播
                              </div>
                              <div
                                class="chapter-review"
                                style="background: #1872ed"
                                v-if="chapter.type == 1 || chapter.type == 4"
                              >
                                直播
                              </div>
                              <div
                                class="chapter-item-title"
                                :class="{ 'chapter-item-title--expanded': expandedChapters[chapter.id] }"
                                :id="'scroll-' + section.sectionId + '-' + idx"
                              >
                                {{ chapter.name }}
                              </div>
                              <div class="keduihuan" v-if="chapter.show == 1">
                                可兑换
                              </div>
                            </div>
                            <div
                              class="item-content-bottom"
                              v-if="!classHideTime || chapter.type != 2"
                            >
                              {{ chapter.start_time ? chapter.start_time.substring(0, 16) : '' }}
                            </div>
                            <!-- lubo -->

                            <template v-if="chapter.videos.length">
                              <div
                                class="chapter-review-item"
                                v-for="video in chapter.videos"
                                :ref="'videoJie' + video.id"
                                :key="video.id"
                                @click="liveAutha(section, chapter, video)"
                                :class="
                                  video.id == reviewActiveId
                                    ? 'review-active'
                                    : ''
                                "
                              >
                                <i class="iconfont">&#xe7e9;</i>
                                <!-- <span class="review-item-name" style="margin-right:5px;width: 109px;" :class="{show: flag == true && id == video.id}" @mouseover="more(video.id)" @mouseout="flag=false">{{ video.name }}</span> -->
                                <span
                                  class="review-item-name"
                                  style="margin-right: 5px; width: 109px"
                                  @mouseover="more(video.id)"
                                  :title="video.name"
                                  >{{ video.name }}</span
                                >
                                <!-- <span style="flex:1"></span> -->
                                <div>
                                  <span class="review-item-time">{{
                                    formateSeconds(video.duration)
                                  }}</span>
                                  <span class="aglook" v-if="video.is">
                                    上次看到
                                  </span>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="live-over">
                            <div
                              v-if="
                                chapter.status === 2 || chapter.status === 4
                              "
                              @click="liveAuth(chapter, chapter.show)"
                              class="live"
                            >
                              <!-- <i class="iconfont live-status" v-if="chapter.status === 2">&#xe6e1;</i> -->
                              <!-- <div class="enter-live">进入直播</div> -->
                              <div class="enter-live">
                                <div
                                  style="
                                    display: flex;
                                    margin: 0 auto;
                                    width: 66px;
                                  "
                                >
                                  <img
                                    v-if="chapter.status === 2"
                                    style="height: 14px; margin-top: 5px"
                                    src="./images/live_icon.gif"
                                    alt=""
                                  />
                                  <span
                                    v-if="chapter.status === 2"
                                    style="margin-left: 4px"
                                    >进入直播</span
                                  >
                                  <span
                                    v-if="!chapter.status === 2"
                                    style="margin-left: 16px"
                                    >进入直播</span
                                  >
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="chapter.status === 3"
                              @click="toggleChapter(chapter.id, section.sectionId)"
                              style="width: 60px"
                            >
                              直播已结束
                            </div>
                            <div class="download">
                              <div
                                class="download_fj"
                                v-if="chapter.file && istoken"
                                @click="
                                  dwxaizaifj(
                                    chapter,
                                    JSON.parse(chapter.file)[0].url,
                                    JSON.parse(chapter.file)[0].title
                                  )
                                "
                                :download="JSON.parse(chapter.file)[0].title"
                                target="_blank"
                              >
                                下载附件
                              </div>
                              <div
                                v-if="
                                  chapter.videos.length > 3 && chapter.type == 3
                                "
                                class="sort"
                              >
                                <div
                                  :class="
                                    sortimgs[chapter.id] ? 'stbx stbx1' : 'stbx'
                                  "
                                  @click="sorta(chapter.id)"
                                >
                                  {{
                                    sortform[chapter.id] == 1
                                      ? '升序'
                                      : sortform[chapter.id] == 0
                                      ? '降序'
                                      : '排序'
                                  }}
                                  <img
                                    class="sortimg"
                                    v-if="!sortimgs[chapter.id]"
                                    src="@/views/images/sort.png"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    class="sortimg"
                                    :src="sortimgs[chapter.id]"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <i
                            v-if="!(chapter.status === 2 || chapter.status === 4)"
                            class="iconfont chapter-expand-icon"
                            @click="toggleChapter(chapter.id, section.sectionId)"
                            :style="{ transform: expandedChapters[chapter.id] ? 'rotate(180deg)' : 'rotate(0deg)' }"
                          >&#xe665;</i>
                        </div>
                      </div>
                    </template>
                    <!-- 无章节 -->
                    <template v-else>
                      <div
                        class="course-chapter-item"
                        v-for="(chapter, idx) in chapterList"
                        :key="chapter.id"
                      >
                        <div class="chapter-item-num">{{ idx + 1 }}</div>
                        <div class="chapter-item-content">
                          <div class="item-content-top">
                            <!-- <div class="chapter-review" v-if="innerItem.videos.length">回放</div> -->
                            <div
                              class="chapter-review"
                              v-if="chapter.type == 3"
                            >
                              回放
                            </div>
                            <div
                              class="chapter-review"
                              v-if="chapter.type == 2"
                            >
                              录播
                            </div>
                            <div
                              class="chapter-review"
                              style="background: #1872ed"
                              v-if="chapter.type == 1 || chapter.type == 4"
                            >
                              直播
                            </div>
                            <div
                              class="chapter-item-title"
                              :title="chapter.name"
                            >
                              {{ chapter.name }}
                            </div>
                            <div class="titleshow">{{ chapter.name }}</div>
                            <div class="keduihuan" v-if="chapter.show == 1">
                              可兑换
                            </div>
                          </div>
                          <div
                            class="item-content-bottom"
                            v-if="!classHideTime || chapter.type != 2"
                          >
                            {{ chapter.start_time }}
                          </div>

                          <template v-if="chapter.videos.length">
                            <div
                              class="chapter-review-item"
                              v-for="video in chapter.videos"
                              :key="video.id"
                              @click="liveAutha({}, chapter, video)"
                              :class="
                                video.id == reviewActiveId
                                  ? 'review-active'
                                  : ''
                              "
                            >
                              <i class="iconfont">&#xe7e9;</i>
                              <span
                                class="review-item-name"
                                style="margin-right: 5px"
                                @click="more"
                                :class="{
                                  show: flag == true && id == video.id,
                                }"
                                >{{ video.name }}</span
                              >
                              <span class="review-item-time">{{
                                formateSeconds(video.duration)
                              }}</span>
                            </div>
                          </template>
                        </div>
                        <div
                          v-if="chapter.status === 2 || chapter.status === 4"
                          @click="liveAuth(chapter, chapter.show)"
                          class="live"
                        >
                          <i
                            class="iconfont live-status"
                            v-if="chapter.status === 2"
                            >&#xe6e1;</i
                          >
                          <div class="enter-live">进入直播</div>
                        </div>
                        <div class="live-over">
                          <div v-if="chapter.status === 3" style="width: 60px">
                            直播已结束
                          </div>
                          <div class="download">
                            <a
                              :href="getDownloadUrl(chapter)"
                              :download="JSON.parse(chapter.file)[0].title"
                              target="_blank"
                              v-if="chapter.file && istoken"
                              >下载附件</a
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div
                v-show="makeNote"
                class="course-chapter note"
                :class="isThreeScreenCourse ? 'three-screen-style' : ''"
              >
                <div class="header">
                  <div class="left">
                    <p>笔记</p>
                    <p v-if="noteTime">自动保存成功:{{ noteTime }}</p>
                  </div>
                  <div class="right">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="我的"
                      placement="top"
                    >
                      <div class="jumpNote">
                        <img
                          src="./images/unnote-h.png"
                          alt=""
                          @click="toMyNote"
                        />
                        <img
                          src="./images/note-h.png"
                          alt=""
                          @click="toMyNote"
                        />
                      </div>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="保存"
                      placement="top"
                    >
                      <div class="saveMyNote">
                        <img
                          src="./images/unnote-save.png"
                          alt=""
                          @click="saveNote()"
                        />
                        <img
                          src="./images/note-save.png"
                          alt=""
                          @click="saveNote()"
                        />
                      </div>
                    </el-tooltip>
                    <div class="closeMyNote">
                      <img
                        src="./images/unnote-close.png"
                        @click="closeNote"
                        alt=""
                      />
                      <img
                        src="./images/note-close.png"
                        @click="closeNote"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="content">
                  <!-- <img @click="signCut" class="cut" src="./images/note-cut.png" alt="">
              <img @click="videoNode" src="./images/note-sign.png" alt="">
              <img @click="saveNote" src="./images/note-save.png" alt=""> -->
                  <TFQuillEditor
                    ref="myQuillEditor"
                    :quill-editor-value="noteContent"
                    @editorContentChange="changeTFQuillEditor"
                    @signCut="signCut"
                    @videoNode="videoNode"
                  />
                  <div
                    class="nodeContainer"
                    v-for="(item, index) in noteNode"
                    :key="index"
                    @click="toNode(item)"
                  >
                    <img src="./images/note-sign.png" alt="" />
                    <span class="time">{{ item.time }}</span>
                    <span class="videoNodeTitle">{{ item.title }}</span>
                    <span
                      style="
                        margin-left: 10px;
                        margin-top: -2px;
                        color: darkgray;
                      "
                      @click="shanchujl(item, index)"
                      >x</span
                    >
                  </div>
                </div>
                <div class="modal-bg" v-if="videNodeShow">
                  <div class="modal-container">
                    <img
                      @click="nodeClose"
                      class="close-img"
                      src="./images/note-node-close.png"
                      alt=""
                    />
                    <div class="modal-header">
                      <img src="./images/note-sign1.png" alt="" />
                      <div class="line"></div>
                      <span>{{ nodeTitle }}</span>
                    </div>
                    <div style="position: relative">
                      <input
                        class="nodde-input"
                        type="text"
                        maxlength="15"
                        placeholder="写点什么(选填)"
                        v-model="nodeContent"
                      />
                      <div class="limit">{{ nodeContent.length }}/15</div>
                    </div>
                    <div class="modal-footer" @click="addNodeConfirm">
                      确认保存
                    </div>
                  </div>
                </div>
                <div class="modal-bg" v-if="closeModelShow">
                  <div
                    class="modal-container"
                    style="width: 303px; height: 152px"
                  >
                    <div class="modal-content">确认退出笔记吗？</div>
                    <div class="model-btn">
                      <p class="nq" @click="noteCancel">取消</p>
                      <p class="nc" @click="nodeCancelConfirm">确认</p>
                    </div>
                  </div>
                </div>
              </div>
              <canvas
                :width="canvasWidth"
                :height="canvasHeight"
                ref="canvas"
                v-show="cropperModel"
              >
              </canvas>
            </div>
          </div>
          <div class="video-consultation">
            <div class="video-consultation-left">
              <p>{{ course.name }}</p>
              <p v-if="numStatus == 1">
                <img src="./images/left.png" alt="" />
                <span>报名人数：{{ studyNum }}</span>
              </p>
            </div>
            <div
              class="video-consualtation-right"
              @click="handleShowWxImg"
              v-if="course.wechat_img"
            >
              <a>立即咨询</a>
            </div>
            <div
            v-if="!istoken"
              class="video-consualtation-rightyi"
              @click="handleShowWxImg1"
            >
              <a>开始学习</a>
            </div>
            <div
              v-if="videoPlay"
              class="video-consultation-center cursor-pointer"
              @click="doNote"
            >
              <img src="./images/note.png" alt="" />
              <span>做笔记</span>
            </div>
            <div v-if="comment" class="video-consultation-mid">
              <span class="video-consultation-mid-box"
                ><span>我的评测：</span>{{ comment }}</span
              >
            </div>
            <div class="contentWx-cover" v-if="isShowWxImg">
              <div class="contentWx-img" v-if="course.wechat_img">
                <div>微信扫一扫咨询</div>
                <img :src="course.wechat_img" alt="" />
                <div>扫码添加咨询顾问咨询课程，资料</div>
                <i class="el-icon-close" @click="handleShowWxImg"></i>
              </div>
              <div class="contentWx-img" v-else>
                <div style="margin-bottom: 100px">暂无咨询方式</div>
                <i class="el-icon-close" @click="handleShowWxImg"></i>
              </div>
            </div>
          </div>
        </div>
        <!-- 课程信息 -->
        <div class="information">
          <div class="information-left">
            <div class="information-container">
              <!-- 课程信息头部 -->
              <div class="information-left-header">
                <div class="information-left-header-left">课程介绍</div>
                <div class="change-class">
                  <div class="class-title">班级:</div>
                  <el-select @change="classChange" v-model="class_id">
                    <el-option
                      v-for="item in options"
                      :key="item.period"
                      :label="item.period"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-html="course.desc" class="info-content"></div>
              <!-- 课程目录 -->
              <!-- <div class="information-left-catalogue">
                <div class="mulu" v-for="(item, index) in chapterList" :key="item.id">
                  <span class="span01">{{ index > 8 ? index + 1 : '0' + (index + 1) }}</span>
                  <div>
                    <p>
                      <span class="leixin" v-if="item.type === 2">回放</span>
                      <span class="leixin" v-else-if="item.type === 1">直播</span>
                      {{ item.name }}
                    </p>
                    <p>{{ item.start_time }}</p>
                  </div>
                  <a @click="liveAuth(item.id)" style="cursor:pointer;">进入直播</a>
                  <div style="width: 700px;height: 60px;margin-left: 66px;margin-top: 10px;" v-for="(item1, index) in item.videos" :key="item1.id">
                    <div>
                      <span class="linyi">{{ index > 8 ? index + 1 : '0' + (index + 1) }}</span>
                      <span class="chushia">{{ item1.name }}</span>
                    </div>
                    <div style="float: right;">
                      <p @click="liveAutha(item1.id)" style="font-size: 14px;color: #10a675;cursor:pointer;margin: auto 0;">看回放</p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <!-- <div class="information-right">
              <div style="width: 300px; margin: 0 auto;">
                <div class="information-right01">
                  <span>LOGO</span>
                  <div>
                    <p>腾慧科技网校</p>
                    <p>业界优秀在线课堂教育机构</p>
                  </div>
                </div>
                <div class="information-right02">
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                </div>
                <div class="information-right03">
                  <p>{{desc}}</p>
                </div>
              </div>
            </div> -->
        </div>
      </div>
      <div style="width: 100%; height: 20px"></div>
      <div style="clear: both"></div>
    </div>
    <Login ref="loginH" @updateLoginState="changeLoginState" />
    <!-- 尾部 -->
    <!-- <bottom></bottom> -->
    <Footer></Footer>
    <!-- 下载附件太大提示弹窗 -->
    <el-dialog
      class="no-down-dialog"
      title="下载附件"
      :visible.sync="noDownVisible"
      width="25%"
      style="border-radius: 16px;"
      center>
      <div class="dialog-con">
        <p>当前附件过大，请复制链接到浏览器中下载。</p>
        <p>下载地址：{{ fileUrl }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noDownVisible = false">取消下载</el-button>
        <el-button type="primary" @click="copyFileUrl(fileUrl)">复制链接</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import banner from './banner';
// import bottom from './bottom'
import cebianlan from './cebianlan';
// import TCPlayer from 'tcplayer.js';
// import 'tcplayer.js/dist/tcplayer.min.css';
import { mapGetters } from 'vuex';
// import TFPlayer from 'tfplayer'
import SHPlayer from 'shplayer';
import Login from './login';
import Footer from './mofang/footer.vue';
import { useOrgConfig } from '@/utils/useUserConfig.js';
import TFQuillEditor from '@/views/components/quillEditor.vue';
import { Message } from 'element-ui';
import VideoDraft from '@/views/components/videoDraft.vue';
import common from '@/utils/common';
import GLOBAL_CONFIG from '../../config/index';
import  { loadScript } from '@/utils/index';

export default {
  data() {
    return {
      noDownVisible: false,
      fileUrl: '',
      hasLiveFlag: false,
      cameraVideoCurTime: 0,
      autoPlayNum: 0,
      canWhiteSeek: true,
      seekingFlag: false,
      classHideTime: false,
      whiteSeekFlag: false,
      cameraSeekFlag: false,
      volume: 80,
      whiteDuration: 0,
      cameraDuration: 0,
      progressTime: 0,
      isVideoEnd: false,
      showPlayIcon: false,
      cameraVideoSpeed: 1,
      whiteBoardSpeed: 1,
      subtitleOptions: {
        bottom: '15px',
      },
      isSelectVideo: false,
      runObj: {
        open: false,
        fontSize: '',
        fontColor: '',
        fontTrans: 1,
        remark: false,
      },
      copyrightObj: {
        open: false,
        inputValue: '',
        copyrightTrans: 1,
      },
      // prev_class_id: '',
      isMuted: false,
      id: 0,
      flag: false,
      sortimgs: {},
      sortform: {},
      expandedChapters: {},
      chapterInitHeight: 24,
      domain: 'www.tengface.com',
      coursesa: [],
      desc: '',
      options: [],
      value: '',
      sectionList: [],
      class_id: '',
      studyNum: '',
      course: {},
      isShowWxImg: false,
      reviewActiveId: '',
      hasSection: true,
      initHeight: 56,
      numStatus: '',
      heartBeat: null,
      videotimet: 0,
      playStatus: '',
      uid: '',
      fileId: '',
      wx_h5_url: 'https://u.shanhuclass.cn',
      currentSectionId: '',
      currentVideoId: '',
      sectionVideoList: [],
      chartTimeDataa: {
        rows: [],
      },
      comment: '',
      isFirst: true,
      curChooseVideo: {},
      cameraVideoUrl: '',
      whiteBoardVideoUrl: '',
      remainingTime: 0,
      code: false,
      codeData: '',
      codeArr: [],
      errData: '',
      cameraVideoPlayer: null,
      whiteBoardPlayer: null,
      tfPlayer: null,
      isThreeScreenCourse: false,
      playParams: {},
      whiteBoardPlayParams: {},
      cameraVideoPlayParams: {},
      memoryPoints: 0,
      playType: '',
      playerType: 'tcPlayer',
      playerThreeType: 'tcPlayer',
      whiteBoardInitOptions: {
        controls: false,
      },
      cameraVideoInitOptions: {
        controlBar: {
          playbackRateMenuButton: false,
        },
      },
      istoken: '',
      shangciGk: true,
      kuaijieshu: false,
      jueshusp: 0,
      calibrationTimer: null,
      nick: '',
      isSwitchPosition: false,
      chapter_id: '',
      makeNote: false,
      noteContent: '',
      canvasWidth: '',
      canvasHeight: '',
      cropperModel: false,
      videNodeShow: false,
      closeModelShow: false,
      nodeTitle: '',
      nodeContent: '',
      noteNode: [],
      memoryTime: '',
      noteCourseId: '',
      noteClassId: '',
      noteSectionId: '',
      noteChapterId: '',
      noteVideoId: '',
      noteTime: '',
      videoPlay: false,
      tabIndex: 1,
      subtitlesStatus: false,
      videoSubtitlesContents: [],
      timer: null,
      canPlayH265: false,
      input2: '', // 搜索
      videoSpeed: 1,
      updateSetTime: null,
      noUpdateNote: false,
      isIOS:
        /iPhone|iPod|iPad/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1),
      lookFileId: '',
      pageSpyUID:[],
      BrowserF: 0,
      BrowserFyi: 0,
      videoAuthLoading: false
    };
  },
  created() {
    const url = `${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/playType.json?id=${new Date().valueOf()}`;
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        this.canPlayH265 = res.canPlayH265
        this.pageSpyUID = res.pageSpyUID || [];
        this.loadPageSpyScript()

      });
    this.istoken = localStorage.getItem('token');
    this.nick = localStorage.getItem('nick');
    this.getConfigSetFn();
  },
  beforeDestroy() {
    const body = document.querySelector('body');
    body.removeAttribute('style');
    window.removeEventListener(
      'beforeunload',
      (e) => this.historycallback(),
      false
    );
    this.recordTimeBeforePageDestroy();
    this.historycallback();
    clearInterval(this.heartBeat);
    clearInterval(this.calibrationTimer);
    clearTimeout(this.updateSetTime);
    document.removeEventListener('keydown', this.handleKeydown, true);
  },
  mounted() {
    if (this.$route.query.zhuanbj) {
      this.doNote(1);
    }
    console.log('[<-- this.$route.query -->]', this.$route.query);

    this.$store.dispatch('getOrgID', this.$store.state.domain).then(() => {
      this.uid = this.$store.state.user.org_id;
      this.getCourseInfo();
      this.listClass();
      this.getMiniConfigAll()
    });
    // this.$nextTick(()=>{
    //   // @loadstart="onLoadstart"
    //   //               :playType="playType"
    //   //               @play="handlePlay"
    //   //               @pause="handlePause"
    //   //               @seeking="handleSeek"
    // console.log(this.$refs.cameraVideo,'cameraVideo');
    // console.log(this.onLoadstart,'onLoadstart');
    // console.log(this.handlePlay,'handlePlay');
    // console.log(this.handlePause,'handlePause');
    // console.log(this.handleSeek,'handleSeek');
    // })
    if (this.$route.query.sectionId) {
      this.playHistoryVideo();
    }
    //监听关闭网页
    window.addEventListener(
      'beforeunload',
      (e) => this.historycallback(),
      true
    );
    document.addEventListener('keydown', this.handleKeydown, true);
  },

  components: {
    banner,
    // bottom,
    Footer,
    cebianlan,
    Login,
    SHPlayer,
    TFQuillEditor,
    VideoDraft,
  },
  computed: {
    // 获取商户id
    ...mapGetters({
      org_id: 'user/getOrgId',
      fans_id: 'user/getFansId',
      remark: 'user/getRemark',
      licenseUrl:'user/getLicenseUrl'
    }),
    // 将秒转化为时分秒
    formateSeconds() {
      return function (endTime) {
        let secondTime = parseInt(endTime); // 将传入的秒的值转化为Number
        let min = 0; // 初始化分
        let h = 0; // 初始化小时
        let result = '';
        if (secondTime > 60) {
          // 如果秒数大于60，将秒数转换成整数
          min = parseInt(secondTime / 60); // 获取分钟，除以60取整数，得到整数分钟
          secondTime = parseInt(secondTime % 60); // 获取秒数，秒数取佘，得到整数秒数
          if (min > 60) {
            // 如果分钟大于60，将分钟转换成小时
            h = parseInt(min / 60); // 获取小时，获取分钟除以60，得到整数小时
            min = parseInt(min % 60); // 获取小时后取佘的分，获取分钟除以60取佘的分
          }
        }
        result = `${h.toString().padStart(2, '0')}:${min
          .toString()
          .padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`;
        return result;
      };
    },
    getDownloadUrl() {
      return (info) => {
        let fileUrl = JSON.parse(info.file)[0].url
        fileUrl = fileUrl.replaceAll(
          'tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com',
          'f1.tengfacexuexi.com'
        )
        return fileUrl
      }
    }
  },
  watch: {
    istoken(val) {
      if (val) {
         this.getRun();
      }
    },
    isThreeScreenCourse(val) {
      this.$nextTick(() => {
        const loadingElArr = document.querySelectorAll('.tcp-loading-spinner');
        if (val) {
          this.calibrationVideo();
          if (loadingElArr.length) {
            for (let i = 0; i < loadingElArr.length; i++) {
              loadingElArr[i].style.opacity = 0;
            }
          }
        } else {
          clearInterval(this.calibrationTimer);
          if (loadingElArr.length) {
            for (let i = 0; i < loadingElArr.length; i++) {
              loadingElArr[i].style.opacity = 1;
            }
          }
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/downloadApp') {
        vm.$nextTick(() => {
          window.location.reload();
        });
      }
    });
  },
  methods: {
    handleKeydown(event) {
      const isVideoFocused = document.activeElement.tagName === 'BODY';
      if (isVideoFocused) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          this.canWhiteSeek = true;
        }
      }
      // 阻止空格键和 alt 键事件传播到 SHPlayer
      if (event.keyCode === 32 || event.key === ' ' || event.keyCode === 18 || event.key === 'Alt') {
        const activeElement = document.activeElement
        const isInputElement = activeElement && (
          activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.isContentEditable
        )
        if (!isInputElement) {
          event.preventDefault()
          event.stopImmediatePropagation()
          // 只有空格键触发播放/暂停
          if (event.keyCode === 32 || event.key === ' ') {
            this.togglePlayPause()
          }
        }
      }
    },
    // 控制监听键盘空格键播放暂停
    togglePlayPause() {
      if (!this.playStatus) return;
      if (this.playStatus === 2) {
        if (this.isThreeScreenCourse) {
          this.$refs.cameraVideo && this.$refs.cameraVideo.pause()
          this.$refs.whiteBoard && this.$refs.whiteBoard.pause()
        } else {
          this.$refs.mainVideo && this.$refs.mainVideo.pause()
        }
      } else {
        if (this.isThreeScreenCourse) {
          this.$refs.cameraVideo && this.$refs.cameraVideo.play()
          this.$refs.whiteBoard && this.$refs.whiteBoard.play()
        } else {
          this.$refs.mainVideo && this.$refs.mainVideo.play()
        }
      }
    },
    BrowserFullScreens(val) {
      this.BrowserF = val
    },
    BrowserFullScreensyi(val) {
      this.BrowserFyi = val
    },
    loadPageSpyScript() {
      console.log(this.pageSpyUID,'this.pageSpyUID',this.fans_id)
         if (this.pageSpyUID && this.pageSpyUID.indexOf(`${this.fans_id}`) !== -1 && !window.$pageSpy) {
            console.log('加载pageSpy')
            loadScript("https://pagespy.shkt.cc/page-spy/index.min.js",()=>{
                // 5. 实例化 PageSpy
                window.$pageSpy = new window.PageSpy({
                // 如果不想 SDK 和调试端建立实时连接，可以开启离线模式
                // offline: true
                });
            });
        }
    },
    onCopy() {
        this.$message.success('复制成功')
    },
    onError() {
        this.$message.error('复制失败')
    },
    handleShowWxImg1() {
      this.$refs.loginH.open();
    },
    getConfigSetFn() {
      const isProd = process.env.NODE_ENV === 'production';
      // 获取是否在后台勾选不允许Mac端登录 /macintosh|mac os x/i.test(navigator.userAgent)
      const host = isProd
        ? 'https://live.shkt.online'
        : 'https://live.tenghuiketang.com';
      const uid = this.$store.state.user.org_id;
      this.$axios
        .post(`${host}/liveapi/customer/index/qryUserConfigs`, { uid })
        .then((res) => {
          if (res && res.data.code === 200) {
            const obj = res.data.data.find(
              (item) => item.key === 'classHideTime'
            );
            if (obj) {
              this.classHideTime = obj.value === 'true';
            }

          }
        });
    },
    async downloadFile(url1, title) {
      const url = url1 // 替换成你要下载的文件的URL
      const fileName = title; // 自定义文件名

      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async copyFileUrl(url) {
      if (!navigator.clipboard) {
          console.error('Clipboard API not supported');
          return;
      }
      try {
          await navigator.clipboard.writeText(url);
          this.$message.success('复制成功')
      } catch (err) {
          this.$message.error('复制失败')
      }
    },
    dwxaizaifj(chapter, item1, title) {
      if(item1) {
        // 因为部分学员DNS拦截导致访问下载链接跳转到了非法网站，所以替换新的域名
        item1 = item1.replaceAll(
          'tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com',
          'f1.tengfacexuexi.com'
        )
      }
      if (chapter.status == 2 || chapter.status == 4 || chapter.status == 3) {
        const { status, id } = chapter;
        const data = {
          course_id: this.$route.params.setid,
          class_id: this.class_id,
          chapter_id: id,
        };
        // 判断附件文件大小
        if (JSON.parse(chapter.file)[0].size > 50) {
          // this.fileUrl = JSON.parse(chapter.file)[0].url
          this.fileUrl = item1
          this.noDownVisible = true
          return;
        }
        // if (status !== 2 && status !== 4) return
        this.$axios.post('/stu/course/liveAuth', data).then((res) => {
          if (res.data.code === 200) {
            // window.open(item1);
            this.downloadFile(item1,title)
          } else if (res.data.code === 400) {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          } else {
            this.$message({
              type: 'info',
              message: '请登录后再试',
            });
          }
        });
      } else {
        console.log('135677-----------111', chapter, item1);
        // 判断附件文件大小
        if (JSON.parse(chapter.file)[0].size > 50) {
          this.fileUrl = item1
          // this.fileUrl = JSON.parse(chapter.file)[0].url
          // 因为部分学员DNS拦截导致访问下载链接跳转到了非法网站，所以替换新的域名
          // this.fileUrl = this.fileUrl.replaceAll(
          //   'tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com',
          //   'f1.tengfacexuexi.com'
          // )
          this.noDownVisible = true
          return;
        }
        const data = {
          course_id: chapter.course_id
            ? chapter.course_id
            : this.$route.params.setid,
          class_id: chapter.class_id ? chapter.class_id : this.class_id,
          chapter_id: chapter.id,
        };
        this.$axios
          .post('https://onlinehy.shkt.online' + '/chapter/chapterAuth', data)
          .then((res) => {
            if (res.data.code === 200) {
              console.log(res.data.data.is_auth);
              if (res.data.data.is_auth == true) {
                // window.open(item1);
                this.downloadFile(item1,title)
              } else {
                this.$message({
                  type: 'info',
                  message: '权限已过期，请联系老师开通',
                });
              }
            } else if (res.data.code === 400) {
              this.$message({
                type: 'info',
                message: res.data.message,
              });
            }
          });
      }
    },
    changeVolume(val) {
      this.volume = val;
    },
    getCameraDuration(val) {
      this.cameraDuration = val;
    },
    getWhiteDuration(val) {
      this.whiteDuration = val;
    },
    playVideo() {
      if (this.isThreeScreenCourse) {
        this.$refs.cameraVideo.play();
        this.$refs.whiteBoard.play();
      } else {
        this.$refs.mainVideo.play();
      }
      this.showPlayIcon = false;
      this.playStatus = 2;
    },
    handlePlaySpeed(val) {
      console.log('handlePlaySpeed: ', val)
      if (this.isThreeScreenCourse) {
        // 三分屏同步播放倍速
        this.cameraVideoSpeed = val;
        this.whiteBoardSpeed = val;
      }
      this.videoSpeed = val;
    },
    shanchujl(item, index) {
      this.noteNode.splice(index, 1);
    },
    getRun() {
      this.$axios
        .post('/stu/courseFunctionList', {
          course_id: this.$route.params.setid,
          org_id: this.org_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            let data = res.data.data;
            data.forEach((item) => {
              if (item.module == 'copyright_statement') {
                if (item.params) {
                  let josnP = JSON.parse(item.params);
                  this.copyrightObj = {
                    open: item.enabled == 'yes' ? true : false,
                    inputValue: josnP.inputValue,
                    copyrightTrans: josnP.copyrightTrans / 100,
                  };
                }
              } else if (item.module == 'running_horse') {
                if (item.params) {
                  let josnP = JSON.parse(item.params);
                  this.runObj = {
                    open: item.enabled == 'yes' ? true : false,
                    fontSize: josnP.fontSize,
                    fontColor: josnP.fontColor,
                    fontTrans: josnP.fontTrans / 100,
                    remark: josnP.remark,
                  };
                }
              }
            });
          }
        });
    },
    toMyNote() {
      this.$router.push({ name: 'zhanghu', query: { setid: '100101' } });
    },
    noteCancel() {
      this.closeModelShow = false;
    },
    nodeCancelConfirm() {
      this.closeModelShow = false;
      this.makeNote = false;
    },
    getCurrentTimeFn() {
      const time = new Date();
      const year = time.getFullYear();
      const month = time.getMonth() + 1;
      const date = time.getDate();
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();
      this.noteTime =
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds;
    },
    async saveNote(item) {
      const res = await this.$axios.post('/stu/course/saveNote', {
        course_id: this.noteCourseId,
        class_id: this.noteClassId,
        section_id: this.noteSectionId,
        chapter_id: this.noteChapterId,
        video_id: this.noteVideoId,
        title: '',
        content: this.noteContent,
        node_mark: JSON.stringify(this.noteNode),
      });
      if (res.data.code == 200) {
        // 自动保存时不提示保存成功文案
        if (this.makeNote && !item) {
          Message.success('保存成功');
        }
        if (item != 1) {
          this.makeNote = false;
        }
      }
    },
    toNode(item) {
      this.$TFWebLog.putLogs(10000, 3, {
          responseData: {
              discription: '网校PC-课程详情-点击笔记修改视频当前时间',
              orgId: this.org_id,
              fansId: this.fans_id,
              currentTime: item,
              isThreeScreenCourse: this.isThreeScreenCourse,
              fileId: this.curChooseVideo.file_id
          }
      })
      if (this.isThreeScreenCourse) {
        this.canWhiteSeek = true;
        this.$refs.cameraVideo.setCurrentTime(item.memory);
      } else {
        this.$refs.mainVideo.setCurrentTime(item.memory);
      }
    },
    addNodeConfirm() {
      this.noteNode.push({
        time: this.nodeTitle,
        title: this.nodeContent,
        memory: this.memoryTime,
      });
      this.nodeTitle = this.nodeContent = this.memoryTime = '';
      this.videNodeShow = false;
    },
    videoNode() {
      if (this.isThreeScreenCourse) {
        const time = this.$refs.whiteBoard.getCurrentTime();
        this.memoryTime = time;
        this.nodeTitle = this.$refs.whiteBoard.time2String(time);
        console.log('[<-- 123 -->]');
      } else {
        console.log('[<--456 -->]');
        const time = this.$refs.mainVideo.getCurrentTime();
        this.memoryTime = time;
        this.nodeTitle = this.$refs.mainVideo.time2String(time);
      }
      this.videNodeShow = true;
    },
    nodeClose() {
      this.nodeTitle = this.nodeContent = this.memoryTime = '';
      this.videNodeShow = false;
    },
    signCut() {
      this.cropperModel = true;
      this.$nextTick(() => {
        this.photograph();
      });
    },
    photograph() {
      // let img =document.getElementById('whiteBoards')
      let img = '';
      if (this.isThreeScreenCourse) {
        img = this.$refs.whiteBoard.getInternalVideoRef();
      } else {
        img = this.$refs.mainVideo.getInternalVideoRef();
      }
      let width = img.clientWidth;
      let height = img.clientHeight;
      this.canvasWidth = width;
      this.canvasHeight = height;
      this.$refs['canvas'].style.display = 'none';
      let ctx = this.$refs['canvas'].getContext('2d');
      this.$nextTick(() => {
        ctx.drawImage(img, 0, 0, width, height);
        let newCanvas = this.$refs['canvas'];
        newCanvas.toBlob(async (blob) => {
          const file = this.blobToFile(blob, 'canvasImage.jpg');
          this.$refs.myQuillEditor.updatefiles(file);
        });
      });
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: 'image/jpeg' });
    },
    closeNote() {
      this.closeModelShow = true;
    },
    changeTFQuillEditor(value) {
      this.noteContent = value;
      // 输入笔记后 等一秒自动保存
      clearTimeout(this.updateSetTime);
      if (!this.noUpdateNote) {
        this.updateSetTime = setTimeout(() => {
          this.saveNote(1);
          this.getCurrentTimeFn();
        }, 1000);
      }
    },
    async doNote(item) {
      const data = {
        chapter_id: this.noteChapterId,
        video_id: this.noteVideoId,
      };
      if (item == 1) {
        data.chapter_id = this.$route.query.chapter_id;
        data.video_id = this.$route.query.video_id;
      }
      const res = await this.$axios.post('/stu/course/getNoteDetail', data);
      console.log('[<-- res -->]', res);
      if (res.data.code == 200) {
        if (res.data.data) {
          this.noteContent = res.data.data.content;
          this.noteNode = res.data.data.node_mark;
          // this.noteTime=res.data.data.time
          this.makeNote = true;
        } else {
          console.log('1255----------', this.$route.query.zhuanbj);
          this.noteContent = '';
          this.noteNode = [];
          this.noteTime = '';
          this.makeNote = true;
        }
      }
      // this.makeNote=true
    },
    cutSwitch() {
      console.log('=======cutSwitch======');
      this.isSwitchPosition = !this.isSwitchPosition;
      let CameraVideoTopDiv = document.getElementById('CameraVideoTopDiv');
      console.log('[<-- CameraVideoTopDiv -->]', CameraVideoTopDiv);
      let CameraVideoDiv = document.getElementById('cameraVideo');
      console.log('[<-- CameraVideoDiv -->]', CameraVideoDiv);
      let whiteBoardTopDiv = document.getElementById('whiteBoardTopDiv');
      console.log('[<-- whiteBoardTopDiv -->]', whiteBoardTopDiv);
      let whiteBoardDiv = document.getElementById('whiteBoard');
      console.log('[<-- whiteBoardDiv -->]', whiteBoardDiv);
      if (this.isSwitchPosition) {
        console.log('切过去');
        CameraVideoTopDiv.after(whiteBoardDiv);
        whiteBoardTopDiv.after(CameraVideoDiv);
        CameraVideoDiv.style.height = '100%';
        whiteBoardDiv.style.height = '200px';
        this.subtitleOptions = {
          bottom: '5px',
          fontSize: '14px',
          padding: '4px 8px',
        };
      } else {
        console.log('切回去');
        CameraVideoTopDiv.after(CameraVideoDiv);
        whiteBoardTopDiv.after(whiteBoardDiv);
        CameraVideoDiv.style.height = '200px';
        whiteBoardDiv.style.height = '100%';
        this.subtitleOptions = {
          bottom: '70px',
        };
      }

      if (this.isThreeScreenCourse) {
        try {
          this.$refs.whiteBoard.resizeScreen();
          this.$refs.cameraVideo.resizeScreen();
        } catch (error) {
          console.log('error', error);
        }
      }
    },
    handleToggleMute(isMuted) {
      // 根据子组件传递过来的 isMuted 值来关闭静音
      this.isMuted = isMuted;
    },
    calibrationVideo() {
      clearInterval(this.calibrationTimer);
      this.calibrationTimer = setInterval(() => {
        // 白板视频不管, 5秒后白板视频来同步头像视频
        if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
          const time = this.$refs.cameraVideo.getCurrentTime();
          // const time2 = this.$refs.whiteBoard.getCurrentTime();
          this.canWhiteSeek = false;
          if (this.cameraDuration > this.whiteDuration) {
            // 头像视频大于白板视频
            const length = this.cameraDuration - this.whiteDuration;
            if (time < length) {
              this.$refs.whiteBoard.setCurrentTime(0, true);
            } else {
              this.$refs.whiteBoard.setCurrentTime(time - length, true);
            }
          } else if (this.cameraDuration < this.whiteDuration) {
            // 白板视频大于头像视频 舍弃多余的白板时长
            const length = this.whiteDuration - this.cameraDuration;
            this.$refs.whiteBoard.setCurrentTime(time + length, true);
          } else {
            // 时间相同 白板视频同步头像视频时长
            this.$refs.whiteBoard.setCurrentTime(time, true);
          }
          if(this.playStatus === 2) {
            this.$TFWebLog.putLogs(10000, 3, {
              responseData: {
                  discription: '网校PC-课程详情-定时器让白板和视频时间同步',
                  orgId: this.org_id,
                  fansId: this.fans_id,
                  currentTime: time,
                  fileId: this.curChooseVideo.file_id
              }
            })
          }
        }
      }, 5000);
    },
    dayusantishi() {
      this.$message({
        type: 'info',
        message: '倍数不能大于3或小于0',
      });
    },
    more(val) {
      this.id = val;
      this.flag = !this.flag;
    },
    playHistoryVideo() {
      let shipingID = localStorage.getItem('shipingID');
      let localViewTime = localStorage.getItem('currentTime' + shipingID);
      const {
        sectionId,
        video_id,
        view_time,
        name,
        chapter_id,
        duration,
        file_id,
      } = this.$route.query;
      const { class_id, setid: course_id } = this.$route.params;
      const section = {
        sectionId,
      };
      const chapter = {
        class_id,
        course_id,
      };
      const video = {
        id: video_id,
        name,
        file_id,
        view_time: view_time ? view_time : localViewTime,
        chapter_id,
        duration,
      };
      if (video_id && this.istoken) {
        this.liveAutha(section, chapter, video);
      }
    },
    historycallback() {
      if (!this.playStatus) return;
      let curTime = '';
      if (this.isThreeScreenCourse) {
        curTime = this.progressTime;
        this.curChooseVideo.duration = Number(
          this.$refs.cameraVideo.videoDuration
        ).toFixed(0);
      } else {
        console.log(this.$refs.mainVideo);
        this.curChooseVideo.duration = Number(
          this.$refs.mainVideo.videoDuration
        ).toFixed(0);
        curTime = this.$refs.mainVideo.getCurrentTime();
      }
      this.curChooseVideo.view_time = curTime;
      this.curChooseVideo.duration =
        this.curChooseVideo.duration != 0
          ? this.curChooseVideo.duration
          : this.videotimet;
      if (Object.entries(this.curChooseVideo).length > 7 && curTime > 0) {
        console.log(this.curChooseVideo, 'this.curChooseVideo');
        this.$axios.post('/user/video/callback', this.curChooseVideo);
      }
    },
    gettoken(token) {
      console.log(token, 'token来了');
      this.istoken = token;
    },
    historycallbacks() {
      if (!this.playStatus) return;
      let curTime = '';
      if (this.isThreeScreenCourse) {
        curTime = this.$refs.cameraVideo.getCurrentTime();
        this.curChooseVideo.duration = Number(
          this.$refs.cameraVideo.videoDuration
        ).toFixed(0);
      } else {
        curTime = this.$refs.mainVideo.getCurrentTime();
        this.curChooseVideo.duration = Number(
          this.$refs.mainVideo.videoDuration
        ).toFixed(0);
      }
      this.curChooseVideo.view_time = curTime;
      this.curChooseVideo.duration =
        this.curChooseVideo.duration != 0
          ? this.curChooseVideo.duration
          : this.videotimet;
      var data = new FormData();
      data.push(this.curChooseVideo);
      Navigator.sendBeacon(
        'https://online.tenghuiwangxiao.cn/user/video/callback',
        data
      );
    },
    async sorta(ind) {
      // console.log(ind);
      let char_sort = '';
      if (!this.sortform[ind]) {
        this.sortform[ind] = 0;
      }
      this.sortform[ind]++;
      if (this.sortform[ind] == 1) {
        this.sortimgs[ind] = require('@/views/images/sorts.png');
        char_sort = 'asc';
      } else if (this.sortform[ind] == 2) {
        this.sortimgs[ind] = require('@/views/images/sortx.png');
        this.sortform[ind] = 0;
        char_sort = 'desc';
      }
      console.log(this.sortform, 'ind');
      await this.getClassCode();
      this.listSections(char_sort);
    },
    async onPlayerEnded() {
      this.isVideoEnd = true;
      if (this.sectionVideoList.length > 0) {
        // 播放结束后 拿到当前章的下标
        const sectionIndex = this.sectionVideoList.findIndex(
          (item) => item.sectionId == this.currentSectionId
        );
        // 判断当前视频后面是否还有视频
        const videoIndex = this.sectionVideoList[sectionIndex].video.findIndex(item => item.id == this.currentVideoId)
        const nextVideoFlag = this.sectionVideoList[sectionIndex].video.length - 1 > videoIndex

        if (!nextVideoFlag && this.sectionVideoList[sectionIndex + 1]) {
          // 取下一章的id
          this.currentSectionId = this.sectionVideoList[sectionIndex + 1].sectionId
          // 取下一章第一个视频的id 只一章一章播放
          // this.currentVideoId = this.sectionVideoList[sectionIndex + 1].video[0].id
        }
        let sectionListVideo = this.sectionVideoList.find(
          (item) => item.sectionId == this.currentSectionId
        );
        if (sectionListVideo) {
          let vidoes = sectionListVideo.video;
          const index = vidoes.findIndex(
            (item) => item.id == this.currentVideoId
          );
          if (!this.$route.query.sectionId) {
            if (index > -1 && index < vidoes.length - 1) {
              let voideItem = vidoes[index + 1];
              // 播放结束
              await this.saveNote();
              // 从数据中找出当前播放的章节视频
              let chapterObj = {}
              this.sectionList.forEach((ele) => {
                ele.chapters.forEach((item) => {
                  item.videos.forEach(video => {
                    if (video.id == voideItem.id) {
                      chapterObj = item
                    }
                  })
                })
              })
              // 调用视频鉴权播放接口
              this.liveAutha(sectionListVideo, chapterObj, voideItem);
            }
          }
        }
      }
    },
    onPlayerPlay() {
      this.playStatus = 2;
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        // if (this.whiteDuration > this.progressTime) {
        this.$refs.whiteBoard.play();
        // }
        //  this.$refs.cameraVideo.play();
      }
    },
    onPlayerPause() {
      this.playStatus = 3;
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        this.$refs.whiteBoard.pause();
        this.$refs.cameraVideo.pause();
      }
      this.$refs.videoDraft && this.$refs.videoDraft.clearTimer();
    },
    onLoadstart() {
      this.playStatus = 2;
      if (this.isThreeScreenCourse) {
        this.$refs.whiteBoard.setCurrentTime(this.memoryPoints, true);
        this.$refs.cameraVideo.setCurrentTime(this.memoryPoints, true);
      } else {
        this.$refs.mainVideo.setCurrentTime(this.memoryPoints, true);
      }
      this.$TFWebLog.putLogs(10000, 3, {
        responseData: {
            discription: '网校PC-课程详情-播放视频器加载完成，可以播放',
            orgId: this.org_id,
            fansId: this.fans_id,
            memoryPoints: this.memoryPoints,
            isThreeScreenCourse: this.isThreeScreenCourse,
            fileId: this.curChooseVideo.file_id
        }
      })
      // 存在参数，跳转播放记忆点
      // this.playStatus = 2
      // if(this.$route.query.sectionId){
      //   if(this.isThreeScreenCourse){
      //     this.$refs.cameraVideo.setCurrentTime(this.memoryPoints)
      //     this.$refs.whiteBoard.setCurrentTime(this.memoryPoints)
      //   }else{
      //     this.$refs.mainVideo.setCurrentTime(this.memoryPoints)
      //   }
      // }
    },
    async classChange(value) {
      //  const selectedItem = this.options.find(item => item.id === value);
      // //  判断是否有该班期权限
      //   if (selectedItem && selectedItem.is_access !== true) {
      //     this.$message({
      //         type: 'info',
      //         message: '您暂无该班级权限，请联系老师开通',
      //       })
      //    this.class_id = this.prev_class_id;
      //   } else {
      //     this.prev_class_id = this.class_id;
      // this.listChapters()
      this.tabIndex = 1;
      this.videoSubtitlesContents = [];
      this.isSelectVideo = false;
      this.classInfo();
      await this.getClassCode();
      this.listSections();
      this.historycallback();
      // }
    },

    // 课程详情接口
    getCourseInfo() {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
      };
      this.$axios.post('/stu/course/getCourseInfo', data).then((res) => {
        if (res.data.code === 200) {
          res.data.data.desc = res.data.data.desc.replace(
            /<img /g,
            '<img style= "width:100%"'
          );
          this.course = res.data.data;
          this.subtitlesStatus =
            res.data.data.is_enable_caption == 1 ? true : false;
        }
      });
    },

    // 课程班级列表接口
    async listClass() {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
      };
      const res = await this.$axios.post('/stu/course/listClass', data);
      console.log(res, 'ggggggggggggggggg');
      if (res.data.code === 200) {
        this.options = res.data.data;
        let hasAccessArr = res.data.data.filter((item) => item.access !== 0);
        if (res.data.data && res.data.data.length > 0) {
          if (hasAccessArr.length === 0) {
            // 没有权限的话，优先展示最新的班级
            this.class_id = res.data.data[0].id // res.data.data[res.data.data.length - 1].id;
          } else {
            this.class_id = hasAccessArr[0].id;
          }
          if (this.$route.params.class_id) {
            this.class_id = parseInt(this.$route.params.class_id);
          }
          // this.prev_class_id=this.class_id
          // this.listChapters()
          this.classInfo();
          await this.getClassCode();
          this.listSections();
        }
      }
    },
    async listSections(char_sort, zitem) {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
        class_id: this.class_id,
        page: 1,
        num: 10,
        char_sort,
      };
      if (char_sort == '' && this.input2 != '') {
        data.key = this.input2;
      }
      const zhangJie =
        this.input2 != ''
          ? '/stu/course/sectionSearch'
          : '/stu/course/listSections';
      const res = await this.$axios.post(zhangJie, data);
      if (res.data.code == 200) {
        if (res.data.data.length) {
          if (res.data.data[0].sectionId) {
            this.sectionList = res.data.data;
            this.hasSection = true;
            this.$nextTick(() => {
              if (this.isFirst) {
                let chapterindex = 0;
                let chapterJie = null;
                let videoJie = null;
                this.expandedChapters = {};
                //let show = 1
                try {
                  this.sectionList.forEach((item, index) => {
                    item.chapters.forEach((item2) => {
                      // 所有节默认展开
                      this.$set(this.expandedChapters, item2.id, true);
                      if (this.codeArr.indexOf(item2.id) != -1) {
                        item2.show = 1;
                      } else {
                        item2.show = 2;
                      }
                      if (item2.status == 2) {
                        chapterindex = index;
                        chapterJie = item2.id;
                        throw new Error(chapterindex);
                      }
                    });
                  });
                  if (!chapterJie) {
                    this.sectionList.forEach((item, index) => {
                      item.chapters.forEach((item2) => {
                        item2.videos.forEach((videoList) => {
                          if (videoList.is) {
                            chapterindex = index;
                            chapterJie = item2.id;
                            videoJie = videoList.id;
                          }
                        });
                      });
                    });
                  }
                } catch (e) {
                  // if (e.message != "End") throw e;
                }
                // 先初始化所有节的收起/展开状态（必须在 handleStretchPart 之前，否则章高度计算错误）
                this.sectionList.forEach((section) => {
                  section.chapters.forEach((ch) => {
                    const el = this.$refs['chapterJie' + ch.id];
                    if (!el || !el[0]) return;
                    const icon = el[0].querySelector('.chapter-expand-icon');
                    if (this.expandedChapters[ch.id]) {
                      if (icon) icon.style.transform = 'rotate(180deg)';
                    } else {
                      el[0].style.height = this.chapterInitHeight + 'px';
                      if (icon) icon.style.transform = 'rotate(0deg)';
                    }
                  });
                });
                if (!char_sort) {
                  // console.log(this.chapterList[0],'this.chapterList[0]');
                  if (this.$route.query.sectionId) {
                    this.handleStretchPart(this.$route.query.sectionId);
                    let scrollTop = document.querySelector('.course-chapter');
                    scrollTop.scrollTop =
                      this.$refs[
                        'part' + this.$route.query.sectionId
                      ][0].offsetTop;
                    // console.log(,'document.querySelector');
                    console.log(
                      this.$refs['part' + this.$route.query.sectionId][0]
                        .offsetTop,
                      'document.sectionId'
                    );
                  } else {
                    this.handleStretchPart(
                      this.sectionList[chapterindex].sectionId
                    );
                  }
                }
                console.log('[<-- this.isFirst -->]', this.isFirst);
                console.log('[<--chapterJie-->]', chapterJie);
                if (this.isFirst && chapterJie) {
                  this.$nextTick(() => {
                    const parent = this.$refs.course_chapter;
                    let position =
                      this.$refs['chapterJie' + chapterJie][0].offsetTop -
                      430 +
                      200;
                    if (videoJie) {
                      position =
                        position +
                        this.$refs['videoJie' + videoJie][0].offsetTop +
                        chapterindex * 44;
                    }
                    console.log(position, 'position');
                    if (position < 0) return;
                    console.log(parent, 'parent');
                    console.log(position, 'position');
                    setTimeout(() => {
                      parent.scrollTo({
                        top: position,
                        behavior: 'smooth',
                      });
                    }, 1000);
                  });
                }
                this.isFirst = false;
              } else {
                if (!char_sort) {
                  this.handleStretchPart(this.sectionList[0].sectionId);
                }
              }
            });
          } else {
            this.chapterList = res.data.data[0].chapters;
            this.hasSection = false;
          }
        } else {
          this.sectionList = res.data.data;
        }
        const list = [];
        this.sectionList.forEach((item) => {
          let vodes = [];
          item.chapters.forEach((item1) => {
            if (this.codeArr.indexOf(item1.id) != -1) {
              item1.show = 1;
            } else {
              item1.show = 2;
            }
            if (item1.videos.length !== 0) {
              vodes = vodes.concat(item1.videos);
            }
          });
          list.push({
            sectionId: item.sectionId,
            video: vodes,
          });
          //  console.log(item.chapters)
        });
        this.sectionVideoList = list;
        console.log('打印视频列表', list);

        // 自动播放上次播放的视频
        if (!char_sort && this.istoken && !this.$route.query.sectionId) {
          this.autoPlayVideoFn()
        }
      }
      if (zitem === 'zhankai' && res.data.data.length && this.input2 != '') {
        this.handleStretchPart(this.sectionList[0].sectionId, 'zhankai');
      }
    },
    autoPlayVideoFn() {
      if (this.autoPlayNum) {
        this.hasLiveFlag = false
        return
      }
      let sectionObj = {}
      let chapterObj = {}
      let videoObj = {}
      if (this.hasSection) {
        // 有章 从数组中拿到上次播放的数据
        this.sectionList.forEach((ele) => {
          ele.chapters.forEach((item) => {
            if (item.status == 2) {
              this.hasLiveFlag = true
            }
            item.videos.forEach(video => {
              if (video.is) {
                videoObj = video
                chapterObj = item
                sectionObj = ele
              }
            })
          })
        })
        if (!Object.keys(videoObj).length) {
          // 没有观看记录的 默认 取第一章第一节的视频
          sectionObj = this.sectionList[0]
          chapterObj = this.sectionList[0].chapters[0]
          videoObj = this.sectionList[0].chapters[0].videos[0]
        }
      } else {
        // 有章 从数组中拿到上次播放的数据
        this.chapterList.forEach((item) => {
          if (item.status == 2) {
            this.hasLiveFlag = true
          }
          item.videos.forEach(video => {
            if (video.is) {
              videoObj = video
              chapterObj = item
            }
          })
        })
        if (!Object.keys(videoObj).length) {
          // 没有观看记录的 默认 取第一章第一节的视频
          chapterObj = this.sectionList[0].chapters[0]
          videoObj = this.sectionList[0].chapters[0].videos[0]
        }
      }

      // 调用鉴权接口 有直播不调用
      if (!this.hasLiveFlag && videoObj && videoObj.chapter_id) {
        this.liveAutha(sectionObj, chapterObj, videoObj)
      }
      this.autoPlayNum += 1
    },
    // 直播鉴权
    liveAuth(item, show) {
      const { status, id } = item;
      const data = {
        course_id: this.$route.params.setid,
        class_id: this.class_id,
        chapter_id: id,
      };

      if (status !== 2 && status !== 4) return;
      this.$axios.post('/stu/course/liveAuth', data).then((res) => {
        if (res.data.code === 200) {
          if (item.type == 4) {
            this.fakeLiveJump(item, res.data);
          } else {
            this.liveAddress(item, res.data);
          }
        } else if (res.data.code === 400) {
          if (show == 1) {
            this.chapter_id = item.id;
            this.errData = '';
            this.code = true;
          } else {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          }
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          });
          this.$refs.loginH.open();
        }
      });
    },
    // 录播鉴权
    liveAutha(section, chapter, video) {
      if (this.videoAuthLoading) return;
	this.$TFWebLog.putLogs(10000, 3, {
					responseData: {
						discription: '调用视频鉴权',
						orgId: this.org_id,
						fansId: this.fans_id,
						fileId: video.file_id
					}
				})
      this.videoAuthLoading = true;
      (this.noteCourseId = chapter.course_id
        ? chapter.course_id
        : this.$route.params.setid),
        (this.noteClassId = chapter.class_id
          ? chapter.class_id
          : this.class_id),
        (this.noteSectionId = section.sectionId);
      this.noteChapterId = video.chapter_id;
      this.noteVideoId = video.id;
      this.historycallback();
      this.videotimet = video.duration;
      console.log('[<-- chapter -->]', chapter);
      console.log(video, '录播鉴权');
      console.log(this.fileId, '录播鉴权fileId');
      this.curChooseVideo = {
        chapter_id: video.chapter_id,
        course_id: chapter.course_id,
        class_id: chapter.class_id,
        video_id: video.id,
        file_id: video.file_id,
        name: video.name,
        duration: video.duration,
        sectionId: section.sectionId,
      };
      this.currentSectionId = section.sectionId;
      this.currentVideoId = video.id;
      const data = {
        course_id: chapter.course_id
          ? chapter.course_id
          : this.$route.params.setid,
        class_id: chapter.class_id ? chapter.class_id : this.class_id,
        chapter_id: video.chapter_id,
        video_id: video.id,
      };
      this.$axios.post('/stu/course/videoAuth', data).then((res) => {
        if (res.data.code === 200) {
          if (
            res.data.data.video.encrypt_status == '1' &&
            res.data.data.video.allow_web == '2'
          ) {
            this.$router.push({ path: '/downloadApp' });
          } else {
            this.videoPlay = true;
            localStorage.setItem('shipingID', video.id);
            this.reviewActiveId = video.id;
            if (video.duration - video.view_time <= 1) {
              this.memoryPoints = 0;
            } else {
              this.memoryPoints = video.view_time;
            }
            if (this.$route.query.memory) {
              this.memoryPoints = this.$route.query.memory;
            }
            this.shangciGk = true;
            let timer = setTimeout(() => {
              this.shangciGk = false;
            }, 5000);
            // this.handlePlayVideo(
            //   res.data.data.video,
            //   res.data.data.new_video,
            //   res.data.data.new_video_wb
            // );
            this.createPlayerParams(res.data.data.video)
            // 心跳上报
            clearInterval(this.calibrationTimer);
            this.fileId = res.data.data.video.file_id
            this.videoSubtitlesContents = []
            this.getVideoSubtitlesContent(this.fileId);
            this.$nextTick(() => {
              this.startVodTime(this.fileId);
              this.remainingTime = 0;
              this.calibrationVideo();
            });
          }
          this.listSections('asc');
        } else if (res.data.code === 400) {
          if (chapter.show == 1) {
            this.chapter_id = chapter.id;
            this.errData = '';
            this.code = true;
          } else {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          }
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          });
          this.$refs.loginH.open();
        }
      }).finally(() => {
        this.videoAuthLoading = false;
      });
    },
    // 定位播放时间
    handleListenCurTimeChange(val) {
      if (this.curChooseVideo.duration - val <= 10) {
        this.kuaijieshu = true;
        if (this.curChooseVideo.duration - val > 1) {
          this.jueshusp = this.curChooseVideo.duration - val;
          // 最后三秒不在自动保存
          this.noUpdateNote = this.curChooseVideo.duration - val < 3;
        }
      } else {
        this.kuaijieshu = false;
      }
      let shipingID = localStorage.getItem('shipingID');
      const currentTime = val;
      this.$refs.videoDraft && this.$refs.videoDraft.setCurrentTime(val);
      localStorage.setItem('currentTime' + shipingID, currentTime);
    },
    handleListenCurTimeChangeCameraVideo(val) {
      this.$refs.videoDraft && this.$refs.videoDraft.setCurrentTime(val);
      this.progressTime = val;
    },
    createPlayerParams(videoInfo) {
      const { original, file_id, appid, s_file_id, s_original, mp4Url, sMp4Url, sign, s_sign ,cfileid, s_cfileid, hx_sign, secret_id, timestamp, encrypt_type,
        s_hx_sign, s_encrypt_type
      } = videoInfo
      let options = null
      if(original === 0) {
        // 如果original=0, 不一定是加密的视频，但是只能播放appid，不能播放视频地址
        // encrypt_status, 则是课程加密
        options = {
          appID: appid,
          psign: sign,
          fileID: cfileid || file_id,
          hxSign: hx_sign,
          hxSecretId: secret_id,
          hxTimestamp: timestamp,
          autoplay: true,
          playType: 'file_id',
          licenseUrl:this.licenseUrl,
          encryptType: encrypt_type
        }
      } else {
        // 非加密视频，直接播放url地址
        options = {
          playType: 'url',
          startTime: this.memoryPoints,
          autoplay: true,
          licenseUrl:this.licenseUrl
        }
      }
      if((mp4Url && sMp4Url) || (file_id && s_file_id)) {
        // 三分屏
        this.isThreeScreenCourse = true
        // 摄像头视频
        options = { ...options, sources: [mp4Url], isEncrypt: original }
        this.playOneVideo(options, 'cameraVideo')
        // 白板视频
        let whiteOptions = {
          appID: appid,
          psign: s_sign,
          isEncrypt: s_original,
          licenseUrl:this.licenseUrl,
          autoplay: true,
          sources: [sMp4Url]
        }
        if(s_original === 0) {
          whiteOptions.fileID = s_cfileid || s_file_id
          whiteOptions.playType = 'file_id'
          whiteOptions.hxSign = s_hx_sign,
          whiteOptions.hxSecretId = secret_id,
          whiteOptions.hxTimestamp = timestamp,
          whiteOptions.encryptType = s_encrypt_type
        } else {
          // whiteOptions.sources = [sMp4Url]
          whiteOptions.playType = 'url'
        }
        this.playOneVideo(whiteOptions, 'whiteBoard')
      } else {
        // 两分屏
        this.isThreeScreenCourse = false
        // 主视频
        options = { ...options, sources: [mp4Url], isEncrypt: original }
        this.playOneVideo(options, 'mainVideo')
      }
    },
    playOneVideo(options, refName) {
      this.showPlayIcon = true
      // 移除固定封面
      this.playStatus = 1
      this.$nextTick(() => {
        this.$refs[refName].setPlayerParams(options)
      })
    },
    singlePlayVideo(options, refName) {
      this.showPlayIcon = true;
      // 移除固定封面
      this.playStatus = 1;
      this.$nextTick(() => {
        this.$refs[refName].setPlayerParams(options);
      });
    },
    // playOneVideo(options, fileIDOption, original) {
    //   const mainVideo = 'mainVideo';
    //   if (this.playerType === 'cPlayer') {
    //     // h265只播url
    //     this.singlePlayVideo(options, mainVideo);
    //   } else {
    //     // h264播放 original===1播Url, 不然播fileId
    //     if (original === 1) {
    //       this.singlePlayVideo(options, mainVideo);
    //     } else {
    //       this.singlePlayVideo(fileIDOption, mainVideo);
    //     }
    //   }
    // },
    playThreeVideo(
      options,
      sOptions,
      fileIDOption,
      sFileIDOption,
      original,
      sOriginal
    ) {
      // 三分屏 判断H265
      const cameraVideo = 'cameraVideo';
      // if (this.playerType === 'cPlayer') {
      //   this.singlePlayVideo({...options,...this.cameraVideoInitOptions}, cameraVideo)
      // } else {
      // h264播放
      if (original === 1) {
        // 播Url
        this.singlePlayVideo(
          { ...options, ...this.cameraVideoInitOptions },
          cameraVideo
        );
      } else {
        // 播fileId
        this.singlePlayVideo(
          { ...fileIDOption, ...this.cameraVideoInitOptions },
          cameraVideo
        );
      }
      // }
      // 白板
      const whiteBoard = 'whiteBoard';
      if (this.playerThreeType === 'cPlayer') {
        this.singlePlayVideo(
          { ...sOptions, ...this.whiteBoardInitOptions },
          whiteBoard
        );
      } else {
        // h264播放
        if (sOriginal === 1) {
          this.singlePlayVideo(
            { ...sOptions, ...this.whiteBoardInitOptions },
            whiteBoard
          );
        } else {
          this.singlePlayVideo(
            { ...sFileIDOption, ...this.whiteBoardInitOptions },
            whiteBoard
          );
        }
      }
    },
    isPCFn() {
      const screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      return screenWidth > 1024 && false;
    },
    // 处理视频播放
    handlePlayVideo(item, new_video, new_video_wb) {
      const {
        mp4Url,
        sMp4Url,
        file_id,
        appid,
        sign,
        s_appid,
        s_file_id,
        s_sign,
        original,
        s_original,
        cfileid,
        s_cfileid
      } = item;
      this.fileId = file_id;
      // let h265Obj = []
      // if (new_video && new_video.length) {
      //   h265Obj = new_video.filter(item => Number(item.vcodec) === 2);
      // }
      let sh265Obj = [];
      if (new_video_wb && new_video_wb.length) {
        sh265Obj = new_video_wb.filter((item) => Number(item.vcodec) === 2);
      }
      // 找出数组中size最小的值
      // const minSize = Math.min(...h265Obj.map(item => item?.size));
      // const m265Obj = h265Obj.find(ele => Number(ele?.size) === minSize)
      const sminSize = Math.min(...sh265Obj.map((item) => item?.size));
      const sm265Obj = sh265Obj.find((ele) => Number(ele?.size) === sminSize);
      // 对视频地址做区分
      if (
        this.isPCFn() &&
        this.canPlayH265 &&
        window.Worker &&
        window.WebAssembly
      ) {
        // this.playerType = h265Obj.length? 'cPlayer' : 'tcPlayer'
        this.playerThreeType = sh265Obj.length ? 'cPlayer' : 'tcPlayer';
      }
      // let videoUrl = this.playerType === 'tcPlayer'? mp4Url : m265Obj?.url // 主视频
      let threeVideoUrl =
        this.playerThreeType === 'tcPlayer' ? sMp4Url : sm265Obj?.url; // 白板视频
      // 播放器创建流程
      const options = {
        sources: [mp4Url],
        playType: 'url',
        startTime: this.memoryPoints,
        autoplay: true,
        licenseUrl:this.licenseUrl
      };
      const sOptions = {
        sources: [threeVideoUrl],
        playType: 'url',
        muted: true,
        autoplay: true,
        startTime: this.memoryPoints,
        licenseUrl:this.licenseUrl
      };
      const fileIDOption = {
        fileID: cfileid || file_id,
        appID: appid,
        psign: sign,
        autoplay: true,
        playType: 'file_id',
        startTime: this.memoryPoints,
        licenseUrl:this.licenseUrl
      };
      const sFileIDOption = {
        fileID: s_cfileid || s_file_id,
        appID: s_appid,
        psign: s_sign,
        playType: 'file_id',
        autoplay: true,
        muted: true,
        startTime: this.memoryPoints,
        licenseUrl:this.licenseUrl
      };
      if ((mp4Url && threeVideoUrl) || (file_id && s_file_id)) {
        // 三分屏
        this.showPlayIcon = true;
        this.isThreeScreenCourse = true;
        this.playThreeVideo(
          options,
          sOptions,
          fileIDOption,
          sFileIDOption,
          original,
          s_original
        );
      } else {
        // 单个视频
        this.isThreeScreenCourse = false;
        this.playOneVideo(options, fileIDOption, original);
      }
    },
    async fakeLiveJump(item1, item) {
      // const liveUrl = `${this.wx_h5_url}/f?ds_id=${item1.ds_id}&tid=${
      //   item1.room_id
      // }&token=${
      //   item.data.liveToken
      // }&other=1&shool_token=${localStorage.getItem('token')}`
      const { live_domain } = await useOrgConfig()
      const liveUrl = `${live_domain}/f/?ds_id=${item1.ds_id}&tid=${
        item1.room_id
      }&token=${item.data.liveToken}&other=1&shool_token=${localStorage.getItem(
        'token'
      )}`;
      if (common.isIPAD) {
        location.href = liveUrl;
      } else {
        window.open(liveUrl);
      }
    },
    // 查询直播地址
    async liveAddress(item1, item) {
      const { live_domain } = await useOrgConfig();
      if (item1.play_style == 4) {
        if (common.isIPAD) {
          location.href = `${live_domain}/tcicMiddlePage/#/pc?classid=${item1.interact_id}&fans_id=${this.fans_id}&ds_id=${item1.ds_id}`;
        } else {
          window.open(
            `${live_domain}/tcicMiddlePage/#/pc?classid=${item1.interact_id}&fans_id=${this.fans_id}&ds_id=${item1.ds_id}`
          );
        }
      } else {
        const liveUrl = `${live_domain}/?ds_id=${item1.ds_id}&token=${
          item.data.liveToken
        }&other=1&shool_token=${localStorage.getItem('token')}`;

        if (common.isIPAD) {
          location.href = liveUrl;
        } else {
          window.open(liveUrl);
        }
      }
    },
    // getMiniConfig(){
    //   this.$axios.get('https://tengface-live.oss-cn-beijing.aliyuncs.com/web/config/userConfig/'+ this.org_id +'.json?a='+ new Date().valueOf())
    //           .then( (response) => {
    //             if (response && response.data) {
    //                 if (response.data.wx_h5_url) {
    //                     this.wx_h5_url = response.data.wx_h5_url
    //                 }
    //             }

    //           })
    //           .catch(function (error) {
    //             console.log(error);
    //           });
    //     },
     getMiniConfigAll(){
      this.$axios.get('https://resshktonline.tengfacexuexi.com/web/config/miniConfig.json?a='+ new Date().valueOf())
          .then( (response) => {
            if (response.data) {
              if (response.data.licenseUrl) {
                // this.licenseUrl = response.data.licenseUrl
                this.$store.commit('user/setLicenseUrl',response.data.licenseUrl)
              }
            }
            //  this.getMiniConfig();
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    // 获取班级信息
    classInfo() {
      const data = {
        org_id: this.org_id,
        classId: this.class_id,
      };
      this.$axios.post('/stu/course/classInfo', data).then((res) => {
        if (res.data.code === 200) {
          this.chapter = res.data.data.chapter;
          this.studyNum = res.data.data.studyNum;
          this.numStatus = res.data.data.numStatus;
          this.comment = res.data.data.comment || '';
        }
      });
    },
    // 展示咨询图片
    handleShowWxImg() {
      this.isShowWxImg = !this.isShowWxImg;
      const body = document.querySelector('body');
      if (this.isShowWxImg) {
        body.setAttribute(
          'style',
          'position:fixed;left: 0px;right: 0px;overflow: hidden;'
        );
      } else {
        body.removeAttribute('style');
      }
    },

    handleStretchPart(id, zhankai) {
      console.log(id, 'id>>>>');
      const el = this.$refs['part' + id];
      const icon = this.$refs['icon' + id];
      let elHeight = el[0].offsetHeight;
      if (elHeight === this.initHeight || zhankai === 'zhankai') {
        el[0].style.height = 'auto';
        elHeight = el[0].offsetHeight;
        el[0].style.height = this.initHeight + 'px';
        let f = document.body.offsetHeight;
        el[0].style.height = elHeight + 'px';
        icon[0].style.transform = 'rotate(180deg)';
      } else {
        el[0].style.height = this.initHeight + 'px';
        icon[0].style.transform = 'rotate(0deg)';
      }
    },
    toggleChapter(chapterId, sectionId) {
      const el = this.$refs['chapterJie' + chapterId];
      if (!el || !el[0]) return;
      const icon = el[0].querySelector('.chapter-expand-icon');
      const oldHeight = el[0].offsetHeight;
      if (oldHeight <= this.chapterInitHeight) {
        // 展开：先算出目标高度
        el[0].style.height = 'auto';
        const newHeight = el[0].offsetHeight;
        el[0].style.height = this.chapterInitHeight + 'px';
        void el[0].offsetHeight;
        el[0].style.height = newHeight + 'px';
        if (icon) icon.style.transform = 'rotate(180deg)';
        this.$set(this.expandedChapters, chapterId, true);
        // 用差值更新父级章高度
        this.updatePartHeight(sectionId, newHeight - this.chapterInitHeight);
      } else {
        // 收起
        el[0].style.height = this.chapterInitHeight + 'px';
        if (icon) icon.style.transform = 'rotate(0deg)';
        this.$set(this.expandedChapters, chapterId, false);
        // 用差值更新父级章高度
        this.updatePartHeight(sectionId, this.chapterInitHeight - oldHeight);
      }
    },
    updatePartHeight(sectionId, delta) {
      const partEl = this.$refs['part' + sectionId];
      if (!partEl || !partEl[0]) return;
      const currentHeight = partEl[0].offsetHeight;
      // 仅在章处于展开状态时（高度大于收起高度）才调整
      if (currentHeight > this.initHeight) {
        partEl[0].style.height = (currentHeight + delta) + 'px';
      }
    },
    // 改变登陆状态
    changeLoginState() {
      this.$refs.header.changeLoginState();
    },
    // 上报心跳
    startVodTime(file_id) {
      this.lookFileId = file_id;
      clearInterval(this.heartBeat);
      this.heartBeat = setInterval(() => {
        if (this.playStatus) {
          let progress = 0;
          if (this.isThreeScreenCourse) {
            progress = this.progressTime;
          } else {
            progress = parseInt(this.$refs.mainVideo.getCurrentTime() || 0);
          }
          // 如果是倍速播放，需要保证每5秒的视频时长都需要有心跳记录,假如当前的progress=100，视频是2倍数，则在记录100秒的同时，还需要记录95秒的视频心跳，后台的观看进度才不会断开
          // 小于1倍数的时候，只需要请求一次视频心跳
          // 修改为将记录的心跳秒数改为5的倍数，方便后端统计，假如观看到了103秒，则向下舍去3秒，从第100秒记录，100 95 90 ....
          progress = progress - progress%5
          let num = this.videoSpeed < 1 ? 1 : Math.ceil(this.videoSpeed);
          while (num > 0) {
            num--;
            const recordSecond = Math.floor(progress - num * 5)
            const heartPayload = {
              file_id,
              fans_id: this.fans_id,
              uid: this.org_id,
              progress: recordSecond >= 0 ? recordSecond : 0,
            }
            this.$liveUser
              .post('/app/index/videoHeart', heartPayload)
              .then(({ data: { code, data, msg } }) => {
                if (code !== 200) {
                   this.$TFWebLog.putLogs(10000, 3, {
                      responseData: {
                          discription: '网校PC-课程详情-视频心跳上报失败1',
                          orgId: this.org_id,
                          fansId: this.fans_id,
                          fileId: file_id,
                          progress: heartPayload.progress
                      }
                    });
                }
              })
              .catch((error) => {
                 this.$TFWebLog.putLogs(10000, 3, {
                    responseData: {
                        discription: '网校PC-课程详情-视频心跳上报失败2',
                        orgId: this.org_id,
                        fansId: this.fans_id,
                        error: error,
                        progress: heartPayload.progress
                    }
                  })
              });

            this.$ws.send(heartPayload)
          }
          // const data = {
          //   file_id,
          //   fans_id: this.fans_id,
          //   uid: this.org_id,
          //   progress,
          // };
          // this.$liveUser
          //   .post('/app/index/videoHeart', data)
          //   .then((res) => {
          //     if (res.data.code !== 200) {
          //       this.errorReport({ msg: '视频心跳接口报错', error: res.data });
          //     }
          //   })
          //   .catch((error) =>
          //     this.errorReport({ msg: '视频心跳报错', error: error })
          //   );
        }
      }, 5000);
    },
    recordTimeBeforePageDestroy() {
      console.log('recordTimeBeforePageDestroy is running: ', this.playStatus);
      // 只有正在直播的时候才记录
      if (this.playStatus !== 2) {
        return;
      }
      let progress = 0;
      if (this.isThreeScreenCourse) {
        progress = this.progressTime;
      } else {
        progress = parseInt(this.$refs.mainVideo.getCurrentTime() || 0);
      }
      progress = progress - progress%5
      this.$liveUser.post('/app/index/videoHeart', {
        file_id: this.lookFileId,
        fans_id: this.fans_id,
        uid: this.org_id,
        progress,
      });
    },
    async errorReport(data) {
      const postData = {
        fans_id: parseInt(this.fans_id),
        error_code: '80000',
        ds_id: 231410,
        uid: parseInt(this.org_id),
        terminal_type: 7,
        data,
      };
      console.log('errorReport', postData)
      // try {
      //   await axios.post(
      //     'https://report.tenghuiwangxiao.cn/app/report/errorReport',
      //     postData
      //   );
      // } catch (error) {
      //   console.log('上报错误');
      // }
    },
    handlePlay() {
      this.playStatus = 2;
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        this.$refs.cameraVideo.play();
        this.$refs.whiteBoard.play();
      }

this.$TFWebLog.putLogs(10000, 3, {
					responseData: {
						discription: '点击了播放按钮',
						orgId: this.org_id,
						fansId: this.fans_id,
						fileId: this.curChooseVideo.file_id
					}
				})
    },
    handlePause() {
      this.playStatus = 3;
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        // if (this.progressTime < this.whiteDuration) {
        //   this.$refs.cameraVideo.pause();
        // }
        this.$refs.whiteBoard.pause();
        this.$refs.cameraVideo.pause();
      }
      this.$refs.videoDraft && this.$refs.videoDraft.clearTimer();
    },
    playingFn() {
      this.showPlayIcon = false;
      this.seekingFlag = false;
    },
    whiteMouseDown(val) {
      console.log('点击事件', val);
      // 用户手动点击了
      this.canWhiteSeek = val;
    },
    handleWhiteSeek(val) {
      // 手动拖动触发, 设置setCurrentTime不要触发
      // 拿到点击事件
      if (this.canWhiteSeek) {
        if (this.cameraDuration > this.whiteDuration) {
          // 头像时长大于白板时长
          const length = this.cameraDuration - this.whiteDuration;
          this.$refs.cameraVideo.setCurrentTime(val + length, true);
        } else if (this.cameraDuration < this.whiteDuration) {
          // 白板时长比头像时长大
          const length = this.whiteDuration - this.cameraDuration;
          this.$refs.cameraVideo.setCurrentTime(val - length, true);
        } else {
          this.$refs.cameraVideo.setCurrentTime(val, true);
        }
        this.seekingFlag = true;
      }
      this.$TFWebLog.putLogs(10000, 3, {
        responseData: {
            discription: '网校PC-课程详情-白班倍数调整',
            orgId: this.org_id,
            fansId: this.fans_id,
            canWhiteSeek: this.canWhiteSeek,
            fileId: this.curChooseVideo.file_id
        }
      })
    },
    compareVideoTime() {
      const cameraTime = this.$refs.cameraVideo.getDuration;
      const courseTime = this.$refs.whiteBoard.getDuration;
      if (cameraTime && courseTime) {
        this.remainingTime = courseTime - cameraTime || 0;
      }
    },
    // 获取当前课程有兑换码章节
    async getClassCode() {
      const data = {
        org_id: this.org_id,
        class_id: this.class_id,
        course_id: this.$route.params.setid,
      };
      const res = await this.$axios.post('/stu/course/getClassCode', data);
      console.log('[<-- resresresres -->]', res);
      if (res.data.code === 200) {
        const cdarr = res.data.data;
        this.codeArr = Object.values(cdarr);
        console.log('[<-- this.codeArr -->]', this.codeArr);
      }
      // .then((res) => {

      // })
    },

    // 兑换码兑换课程
    useCdk() {
      const data = {
        org_id: this.org_id,
        code: this.codeData,
        class_id: this.class_id,
        course_id: this.$route.params.setid,
        chapter_id: this.chapter_id,
      };
      this.$axios.post('/stu/course/useCdk', data).then((res) => {
        console.log(res.data.code);
        if (res.data.code === 200) {
          this.$message({
            message: '兑换成功!',
            type: 'success',
          });
          this.code = false;
          this.codeData = '';
          this.videoPlay = true;
        } else if (res.data.code === 400) {
          this.errData = res.data.message;
        }
      });
    },
    /**
     * 描述：获取视频字幕
     **/
    getVideoSubtitlesContent(id) {
      this.$subApi
        .post('/caption/getCaptionContentList', {
          file_id: id,
          // file_id: '1253642695935868212'
        })
        .then((res) => {
          if (res && res?.data?.code !== 200) {
            this.$message.error('获取字幕内容失败');
            return;
          }
          this.videoSubtitlesContents = res?.data?.data;
          if (this.subtitlesStatus) {
            this.isSelectVideo = true;
          }
          return;
        });
    },
    tabChange(index) {
      this.tabIndex = index;
    },
    /**
     * 描述：更新播放器时间
     * @param   : val {number} 字幕开始时间
     **/
    updatePlayerTime(val) {
      if (this.isThreeScreenCourse) {
        // 三分屏设置摄像头播放器时间
        // this.canWhiteSeek = true;
        // 字幕对头像的时间
        this.$refs.cameraVideo && this.$refs.cameraVideo.setCurrentTime(val);
        // 头像跳转时候后,把白板的时间立即同步过来
        if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
          this.canWhiteSeek = false;
          if (this.cameraDuration > this.whiteDuration) {
            // 头像视频大于白板视频
            const length = this.cameraDuration - this.whiteDuration;
            if (val < length) {
              this.$refs.whiteBoard.setCurrentTime(0, true);
            } else {
              this.$refs.whiteBoard.setCurrentTime(val - length, true);
            }
          } else if (this.cameraDuration < this.whiteDuration) {
            // 白板视频大于头像视频 舍弃多余的白板时长
            const length = this.whiteDuration - this.cameraDuration;
            this.$refs.whiteBoard.setCurrentTime(val + length, true);
          } else {
            // 时间相同 白板视频同步头像视频时长
            this.$refs.whiteBoard.setCurrentTime(val, true);
          }
        }
      } else {
        this.$refs.mainVideo && this.$refs.mainVideo.setCurrentTime(val);
      }
      this.$TFWebLog.putLogs(10000, 3, {
        responseData: {
            discription: '网校PC-课程详情-点击了字幕内容后触发播放器更新',
            orgId: this.org_id,
            fansId: this.fans_id,
            subtitleTime: val,
            isThreeScreenCourse: this.isThreeScreenCourse,
            fileId: this.curChooseVideo.file_id
        }
      })
    },
    playLineChange(line) {
      this.$refs.cameraVideo && this.$refs.cameraVideo.setPlayLine(line)
    }
  },
};
</script>
<style scoped>
.sousuozj >>> .el-input__inner {
  border: none;
  background: #2b2c35;
  border-radius: 20px;
}
.shangcigkyi {
  width: 135px;
  height: 38px;
  background: rgba(21, 21, 21, 0.8);
  border-radius: 4px;
  position: absolute;
  margin-top: -100px;
  margin-left: 685px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 38px;
}
.shangcigk {
  width: 140px;
  height: 30px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 2px;
  position: absolute;
  margin-top: -90px;
  margin-left: 10px;
  font-size: 14px;
  font-family: Inter, Inter-400;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
}
.video >>> .vod-player .main .progress #tf_progress_point {
  margin-top: -4px;
}
.yuyuyu >>> .el-dialog {
  margin-top: 0 !important;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.yuyuyu >>> .el-input {
  box-sizing: border-box;
  width: 220px;
  height: 44px;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #1872ed;
}
.video >>> .vod-player .main .progress #tf_progress_view {
  top: -2px;
}
.kechengduihuan {
  font-size: 20px;
  font-family: PingFangSC-Medium;
  text-align: center;
  color: #202020;
}
.huoqulist {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  margin-top: 1px;
}
.duihuan-content {
  width: 244px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yuyuyu::v-deep .el-input .el-input__inner {
  width: 100%;
  height: 100%;
  border: none;
}
.lijiduan {
  width: 50px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  border-radius: 0px 4px 4px 0px;
  background: #1872ed;
  border: none;
  color: #fff;
}
.keduihuan {
  width: 40px;
  height: 16px;
  background: #f33f27;
  border-radius: 2px;
  font-size: 10px;
  font-family: PingFangSC-Regular;
  text-align: center;
  color: #ffffff;
  margin-left: 5px;
  padding-right: 2px;
  /* line-height: 14px;
  padding-left: 2px; */
  line-height: 16px;
}
.yiguoqilist {
  font-size: 10px;
  font-family: PingFangSC-Regular;
  text-align: left;
  color: #ff5227;
  line-height: 20px;
  padding-left: 15px;
}
.yuyuyu >>> .el-dialog--center .el-dialog__body {
  padding: 25px 25px 0px;
}
</style>
<style lang="scss" scoped>
/* 公共样式 */
* {
  padding: 0;
  margin: 0;
}

a {
  color: #434343;
  text-decoration: none;
  /* 取消下划线 */
}

li {
  list-style: none;
}
p {
  margin: 0;
  padding: 0;
}

body {
  background-color: #fff;
  /* 整个页面的颜色 */
  font-size: 14px;
}

input {
  border: 0;
  /* 所有的input边框为0 */
  outline: none;
  /* 去掉默认边框 */
  box-sizing: border-box;
  /* css3模型 border和padding 包含在盒子里 */
}

.container {
  margin: 0 auto;
  // padding-left: calc(100vw - 100%);
}

/* 课程详情部分开始 */
.details {
  background-color: #f5f6f7;
  padding-bottom: 30px;
  min-width: 972px;
}

.details-header {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #4d4d4d;
}

.details-header a {
  color: #545454;
}

.details-header span {
  color: #545454;
  padding: 0 14px;
}
.course-img {
  position: relative;
  background-position: center;
  background-size: cover;
  //min-width: 645px;
  min-height: 430px;
  .main-video {
    width: 100%;
    height: 100%;
  }
  .whiteBoard {
    width: 100%;
    height: 100%;
  }
  .overlayer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 60px;
      cursor: pointer;
    }
  }
}
.course-imger {
  height: 200px;
  position: relative;
}
.course-imgyi {
  position: fixed; /* 固定定位 */
  top: 0; /* 顶部贴紧 */
  left: 0; /* 左侧贴紧 */
  width: 100% !important; /* 宽度100% */
  height: 100% !important; /* 高度100% */
  z-index: 1000; /* 确保在页面其他元素之上 */
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  .main-video {
    width: 100%;
    height: 100%;
  }
  .whiteBoard {
    width: 100%;
    height: 100%;
  }
  .overlayer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 60px;
      cursor: pointer;
    }
  }
}

.video-population {
  height: 600px;
}

.video-playback {
  width: 900px;
  height: 600px;
  float: left;
  background-color: pink;
}

.video-details {
  width: 360px;
  height: 600px;
  float: left;
  background-color: #191a20;
  overflow-y: scroll;
}

.video-details ul li {
  height: 70px;
}

.video-details a {
  display: block;
  height: 70px;
  margin-bottom: 6px;
}

.video-details a .span02 {
  display: block;
  width: 21px;
  height: 28px;
  float: left;
  margin: 20px 17px 0 24px;
  text-align: center;
  color: #515151;
  font-size: 18px;
  font-weight: 500;
}

.video-details a div {
  float: left;
  margin-top: 20px;
}

.video-details a div p {
  font-size: 16px;
  color: #b7b7b7;
}

.video-details a div p span {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #ff9d2d;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.video-details a div p:last-child {
  color: #515151;
  font-size: 12px;
  margin-top: 5px;
}

/* ????? */
.video-details a:hover p {
  color: #10a675;
}

.video-details a:hover .span02 {
  color: #10a675;
}

.video-details a:hover p:last-child {
  color: #10a675;
}

.video-details a:focus p {
  color: #10a675;
}

.video-details a:focus .span02 {
  color: #10a675;
}

.video-details a:focus p:last-child {
  color: #10a675;
}

.video-consultation {
  height: 90px;
  background-color: #222328;
  position: relative;
}

.video-consultation-left {
  float: left;
  margin-left: 30px;
  // width: 900px;
  height: 90px;
}

.video-consultation-left p:first-child {
  padding-top: 20px;
  font-size: 24px;
  font-weight: 700;
  color: #b7b7b7;
  margin-bottom: 10px;
}

.video-consultation-left p:nth-child(2) {
  display: block;
  float: left;
  padding-right: 40px;
  color: #7e7e7f;
}

.video-consultation-left p img {
  padding-right: 10px;
}

.video-consultation-left p:last-child {
  display: block;
  float: left;
  color: #7e7e7f;
}
.video-consultation-center {
  position: absolute;
  top: 34px;
  right: 390px;
  width: 76px;
  height: 22px;
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-right: 60px;
  // padding-top: 34px;
  img {
    display: inline-block;
    height: 20px;
    width: 20px;
  }
  span {
    height: 22px;
    display: inline-block;
    margin-left: 8px;
    text-align: center;
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
  }
}
.video-consualtation-rightyi {
  width: 300px;
  padding-right: 30px;
  padding-top: 17px;
  float: right;
  cursor: pointer;
}
.video-consualtation-right {
  width: 300px;
  padding-right: 30px;
  padding-top: 17px;
  float: right;
  cursor: pointer;
}

.video-consultation-mid {
  padding-top: 17px;
  float: right;
  color: #b7b7b7;
  width: 300px;
  font-size: 22px;
  margin-right: 46px;
}

.video-consultation-mid-box {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.video-consualtation-rightyi a {
  display: block;
  // width: 300px;
  height: 57px;
  // border: 1px solid #1872ed;
  color: #1872ed;
  background: #fff;
  font-size: 22px;
  border-radius: 25px;
  line-height: 57px;
  text-align: center;
}
.video-consualtation-right a {
  display: block;
  // width: 300px;
  height: 57px;
  background: linear-gradient(132deg, #73aaff 2%, #0053ff 93%);
  color: #ffffff;
  font-size: 22px;
  border-radius: 25px;
  line-height: 57px;
  text-align: center;
}

/* 信息部分 */
.information {
  margin-top: 20px;
}

.information-container {
  width: 810px;
  margin: 0 auto;
  margin-bottom: 20px;
}
/* 切换班级样式 */
.change-class {
  display: flex;
  padding: 10px 0;
  align-items: center;
}
.class-title {
  margin-right: 10px;
}
.el-select-dropdown__item {
  margin-left: 15px;
}
.information-left {
  // width: 870px;
  width: 972px;
  float: left;
  background-color: #ffffff;
  padding-bottom: 20px;
}

.information-left-header {
  border-bottom: 2px solid #e8eaec;
  line-height: 20px;
  font-size: 16px;
  display: flex;
}
.information-left-header .change-class {
  margin-left: auto;
}

.information-left-header-left {
  padding: 22px 0;
  font-size: 16px;
  color: #20242f;
  border-bottom: 1px solid #e8eaec;
  font-weight: 700;
  border: none;
}
.info-content {
  font-size: 14px;
}

.information-left-header-left a:nth-child(2) {
  margin: 0 60px;
}

.information-left-header-left a:nth-child(2) span {
  padding-bottom: 18px;
  border-bottom: 4px solid #10a675;
}

.information-left-header-right {
  float: right;
}

.information-left-header-right img {
  padding-right: 8px;
}
.course-content-main {
  display: flex;
}
@media screen and (max-width: 992px) {
  .course-chapter {
    max-height: 430px;
    position: relative;
  }
}
@media screen and (max-width: 1280px) {
  .course-chapter {
    max-height: 430px;
    position: relative;
  }
}
.course-chapter {
  background: #191a20;
  flex: 1;
  overflow-y: auto;
  color: #b7b7b7;
  // padding: 0 20px;
  position: relative;
  box-sizing: border-box;
  min-width: 375px;
  .chapter-main {
    overflow: hidden;
    transition: all 0.5s;
    height: 56px;
    padding: 0 20px;
  }
  .camera-video {
    width: 100%;
    height: 100%;
  }
}
/* 滚动条样式 */
.course-chapter::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.course-chapter::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.course-chapter::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.note {
  background: #fff;
  padding: 0 12px;
  position: relative;
  color: #202020;
  width: 335px;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    p:nth-child(1) {
      font-weight: 600;
      font-size: 16px;
      color: #202020;
    }
    p:nth-child(2) {
      margin-left: 10px;
      margin-top: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 24px;
      width: 24px;
    }
    .saveMyNote {
      margin-left: 8px;
    }
    .closeMyNote {
      margin-left: 8px;
    }
    .jumpNote img:nth-child(1) {
      display: block;
    }
    .jumpNote img:nth-child(2) {
      display: none;
    }
    .saveMyNote img:nth-child(1) {
      display: block;
    }
    .saveMyNote img:nth-child(2) {
      display: none;
    }
    .closeMyNote img:nth-child(1) {
      display: block;
    }
    .closeMyNote img:nth-child(2) {
      display: none;
    }
    .jumpNote:hover img:nth-child(1) {
      display: none;
    }
    .jumpNote:hover img:nth-child(2) {
      display: block;
    }
    .saveMyNote:hover img:nth-child(1) {
      display: none;
    }
    .saveMyNote:hover img:nth-child(2) {
      display: block;
    }
    .closeMyNote:hover img:nth-child(1) {
      display: none;
    }
    .closeMyNote:hover img:nth-child(2) {
      display: block;
    }
  }
  .content {
    position: relative;
    height: 100%;
    img {
      display: inline-block;
      height: 18px;
      width: 18px;
    }
    .cut {
      position: absolute;
      top: 85px;
      left: 140px;
    }
    img:nth-child(2) {
      position: absolute;
      top: 85px;
      left: 170px;
    }
    img:nth-child(3) {
      position: absolute;
      top: 85px;
      left: 200px;
    }
  }
}
.modal-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .modal-container {
    width: 314px;
    height: 186px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .close-img {
      width: 16px;
      height: 16px;
      float: right;
      margin-top: 20px;
      margin-right: 20px;
    }
    .modal-header {
      margin-top: 30px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: #202020;
      img {
        width: 20px;
        height: 20px;
      }
      .line {
        display: inline-block;
        width: 1px;
        height: 16px;
        background: #999999;
        margin: 0 10px;
      }
    }
    .nodde-input {
      width: 274px;
      height: 36px;
      background: #efefef;
      border-radius: 4px;
      margin: 20px;
      padding: 0 10px;
    }
    .limit {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      position: absolute;
      top: 30px;
      right: 30px;
    }
    .modal-footer {
      width: 164px;
      height: 34px;
      background: linear-gradient(100deg, #73aaff 0%, #0053ff 100%);
      border-radius: 22px;
      margin: 0 75px;
      text-align: center;
      line-height: 34px;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
    }
    .modal-content {
      font-size: 16px;
      font-weight: 400;
      color: #202020;
      margin: 30px 0;
      width: 100%;
      text-align: center;
    }
    .model-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .nq {
        width: 112px;
        height: 40px;
        background: #dfe3e8;
        border-radius: 30px;
        border-radius: 30px;
        margin-right: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #202020;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
      .nc {
        width: 112px;
        height: 40px;
        background: linear-gradient(107deg, #73aaff 0%, #0053ff 100%);
        border-radius: 22px;
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
      }
    }
  }
}
.nodeContainer {
  width: fit-content;
  height: 20px;
  background: #f1f2f7;
  border-radius: 40px;
  padding: 7px 16px;
  font-size: 14px;
  font-weight: 400;
  color: #202020;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-top: 10px;
  img {
    height: 16px !important;
    width: 16px !important;
    margin-right: 6px;
  }
  .time {
    margin-right: 10px;
  }
  .videoNodeTitle {
    display: inline-block;
    white-space: nowrap;
  }
}
.contentWx-cover {
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0;
  background: #0c0d1094;
  z-index: 1000;
}
.aglook {
  width: 48px;
  padding: 2px 5px;
  color: white;
  background: #1872ed;
  margin-left: 10px;
  border-radius: 5px;
  font-size: 12px;
  position: absolute;
}
.contentWx-img {
  width: 400px;
  height: 400px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
  z-index: 998;
}
.contentWx-img {
  width: 400px;
  height: 400px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
}
.contentWx-img div:first-child {
  font-size: 24px;
}
.contentWx-img div:last-child {
  font-size: 20px;
}
.contentWx-cover img {
  width: 40%;
  margin: 20px 0;
}
.contentWx-img i {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 25px;
  background: #fff;
  color: #888888;
  border: none;
  cursor: pointer;
}

.confirm {
  margin-top: 35px;
  width: 240px;
  height: 57px;
  background: linear-gradient(133deg, #73aaff 3%, #0053ff 91%);
  border-radius: 29px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  line-height: 57px;
  color: #ffffff;
}
/* 目录信息 */
.information-left-catalogue {
  height: 1100px;
}

.information-left-catalogue .mulu {
  min-height: 90px;
  width: 810px;
  margin-top: 20px;
  background-color: #f9f9f9;
}

.information-left-catalogue div {
  display: block;
}

.information-left-catalogue div {
  float: left;
  margin-top: 20px;
}

.information-left-catalogue p {
  font-size: 16px;
  color: #20242f;
}

.information-left-catalogue .leixin {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #10a675;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.span01 {
  display: block;
  width: 27px;
  height: 28px;
  float: left;
  margin: 16px 20px 0 20px;
  text-align: center;
  color: #10a675;
  font-size: 24px;
}

.information-left-catalogue p:last-child {
  color: #808695;
  font-size: 14px;
  margin-top: 20px;
}

.information-left-catalogue a {
  height: 30px;
  width: 90px;
  line-height: 30px;
  text-align: center;
  display: block;
  float: right;
  border: 1px solid #10a675;
  border-radius: 25px;
  margin-top: 29px;
  margin-right: 20px;
}

/* 右边 */
.information-right {
  width: 360px;
  float: right;
  background-color: #ffffff;
}

.information-right01 {
  height: 84px;
  margin-top: 22px;
}

.information-right01 span {
  display: block;
  float: left;
  height: 64px;
  width: 55px;
  line-height: 64px;
  color: #ffffff;
  background-color: #10a675;
  padding-left: 9px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: 700;
  border-radius: 10px;
}

.information-right01 div {
  float: left;
  padding-left: 12px;
}

.information-right01 div p:first-child {
  font-size: 20px;
  padding-top: 3px;
}

.information-right01 div p:last-child {
  color: #9a9fab;
  padding-top: 10px;
}

.information-right02 {
  height: 72px;
}

.information-right02 div {
  width: 93.3px;
  height: 72px;
  text-align: center;
  background-color: #f9f9f9;
  float: left;
}

.information-right02 div:nth-child(2) {
  margin: 0 10px;
}

.information-right02 div p {
  color: #9fa4af;
  padding: 15px 0;
}

.information-right03 {
  margin-top: 25px;
  margin-bottom: 20px;
}

.information-right03 p {
  text-indent: 2em;
  /* 首行缩进 */
  line-height: 150%;
}

.information-right03 p span {
  letter-spacing: 1px;
}

/* 课程详情部分结束 */
/* 合作与联系开始 */
.contact {
  height: 210px;
  background-color: #101115;
}

.contact-left {
  float: left;
}

.contact-left dt {
  color: #82858a;
  font-size: 20px;
  font-weight: 700;
  padding-top: 55px;
  padding-bottom: 12px;
  letter-spacing: 4px;
  /* 字间距为4px */
}

.contact-left dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-right {
  float: right;
}

.contact-right img {
  padding-top: 46px;
  padding-bottom: 12px;
}

.contact-right p {
  color: #65676c;
}

.contact-middle {
  float: right;
  margin-right: 93px;
}

.contact-middle dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-middle dd:first-child {
  padding-top: 52px;
}

.contact-middle dd:nth-child(2) {
  padding-top: 20px;
}

.contact-middle dd:last-child {
  padding-top: 14px;
}

.contact-middle dt {
  color: #82858a;
  font-size: 20px;
  padding-top: 23px;
}

/* 合作与联系结束 */
/* 尾部开始 */
.tail {
  height: 50px;
  line-height: 50px;
  background-color: #0c0d10;
}

.tail p {
  width: 100%;
  color: #65676c;
  font-size: 13px;
  margin: auto;
  text-align: center;
}
.chapter-title {
  height: 44px;
  width: 100%;
  margin-top: 12px;
  font-size: 16px;
  color: #e6e6e6;
  line-height: 44px;
  background: #2b2c35;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  .chapter-text {
    display: block;
    width: 95%;
    max-width: 310px;
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconfont {
    position: absolute;
    right: 10px;
    top: 0;
    transition: all 0.5s;
  }
}

.course-chapter-item {
  margin-top: 20px;
  padding: 0 16px 0 24px;
  display: flex;
  cursor: pointer;
  overflow: hidden;
  transition: height 0.3s ease;
}
.chapter-item-num {
  margin-right: 12px;
  font-size: 18px;
  color: #515151;
  line-height: 1;
}
.chapter-item-content {
  position: relative;
  flex: 1;
}
.item-content-top {
  display: flex;
  align-items: start;
  position: relative;
  margin-bottom: 16px;
}
.chapter-expand-icon {
  margin-left: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  transition: transform 0.3s;
  flex-shrink: 0;
  align-self: flex-start;
}

.sort {
  position: relative;
  // right: -60px;
  width: 100%;
  display: flex;
  // margin: 8px 0px;;
  font-size: 12px;
  justify-content: right;
}
.stbx {
  // position: absolute;
  // top: -33px;
  // right: -55px;
  width: 48px;
  height: 20px;
  display: flex;
  z-index: 88;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: solid #b7b7b7 1px;
}
.stbx1 {
  color: #1872ed;
  border: solid #1872ed 1px;
}
.sortimg {
  width: 8px;
  height: 8px;
}
.chapter-review {
  min-width: 30px;
  height: 16px;
  font-size: 12px;
  color: #ffffff;
  background: #ff9d2d;
  border-radius: 2px;
  text-align: center;
  margin-right: 8px;
}
.chapter-no-review {
  width: 30px;
  height: 16px;
  margin-right: 8px;
}

.chapter-item-title {
  font-size: 16px;
  color: #b7b7b7;
  line-height: 1;
  font-weight: 700;
  max-width: 115px;
  overflow: hidden; // （文字长度超出限定宽度，则隐藏超出的内容）
  white-space: nowrap; // （设置文字在一行显示，不能换行）
  text-overflow: ellipsis; // （规定当文本溢出时，显示省略符号来代表被修剪的文本）
}
.chapter-item-title--expanded:hover {
  white-space: pre-wrap;
  height: auto;
  overflow: visible;
}
.item-content-bottom {
  font-size: 12px;
  color: #515151;
  margin-bottom: 16px;
}
.chapter-review-item {
  font-size: 14px;
  color: #b7b7b7;
  display: flex;
  margin-bottom: 16px;
  position: relative;
  .review-item-name {
    display: block;
    width: 120px !important;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .show {
    width: 120px !important;
    color: #1872ed;
    white-space: pre-wrap;
    height: auto;
    overflow: visible;
  }
  .iconfont {
    margin-right: 6px;
    transform: translateY(1px);
  }
}
.review-active {
  color: #1872ed;
}
.chapter-review-item img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
// .review-item-time {
//   position: absolute;
//   right: 0px;
// }
.live {
  display: flex;
}
.enter-live {
  font-size: 12px;
  width: 80px;
  height: 24px;
  background: #1872ed;
  color: #fefffe;
  line-height: 24px;
  text-align: center;
  border-radius: 16px;
  transform: translateY(3px);
  margin-left: 6px;
}
.live-status {
  color: #1872ed;
  transform: translateY(4px);
}
.live-over {
  color: #b7b7b7;
  font-size: 12px;
  text-align: center;
  // transform: translateY(5px);
  .download {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-top: 18px;
  }
  .download_fj {
    width: 48px;
    height: 18px;
    white-space: nowrap;
    text-align: center;
    line-height: 18px;
    display: block;
    padding: 2px;
    background-color: #1872ed;
    border-radius: 25px;
    margin-right: 5px;
    padding: 2px 6px;
    color: #fff;
  }
}
.titleshow {
  display: none;
  width: 100%;
  position: absolute;
  top: 32px;
  z-index: 99;
  left: 0;
  background: #333333;
}
.item-content-top:hover .titleshow {
  display: block;
}

.main-video {
  ::v-deep .progress {
    height: 4px !important;
  }
  ::v-deep .progress #tf_progress_point {
    width: 16px !important;
    height: 16px !important;
    border-radius: 8px !important;
    transform: translate(-3px, -6px) !important;
  }
}
.course-content-main-right {
  .class-tab {
    background: #2b2c35;
    color: #adb5bd;
    .tab-list {
      display: flex;
      justify-content: space-around;
      padding: 0 40px;
      font-size: 18px;
      .tab-item {
        padding: 8px 0;
        cursor: pointer;
        &.active {
          color: #ffffff;
          border-bottom: 2px solid #1872ed;
        }
      }
    }
  }
}

/* 尾部结束 */
</style>

<style lang="scss">
.no-down-dialog {
  .el-dialog--center {
    width: 406px !important;
  }
}

</style>
